/* eslint-disable @typescript-eslint/no-explicit-any */
import type { Currency } from '@swf/core/enums';

export type MappedMarketsUpdates = Record<string, MarketUpdate | undefined>;

export interface ActiveAntePostBasedMyBetPart {
  eventTypeId: EventType;
  marketType: 'ANTEPOST_WIN';
  deadHeatWinDeductions?: number;
  deadHeatEachwayDeductions?: number;
  eachwayFactor?: Fraction;
  eachwayPlaces?: number;
  eventDescription?: string;
  eventId?: string;
  eventMarketTemplateDescription?: string;
  marketId?: string;
  rule4Deductions?: number;
  selectionId?: SelectionId;
  selectionName?: string;
  sportId?: string;
  startTime?: string;
  priceType?: PriceType;
  inPlay: boolean;
  odds?: Odds;
  handicap?: Handicap;
  marketLevels?: MarketLevels;
  venue?: string;
  eventTypeSlug: string;
  eventSlug: string;
  raceId?: string;
}

export interface ActiveEventBasedMyBetPart {
  eventTypeSlug: string;
  eventTypeId: EventType;
  competitionSlug: string;
  competitionId: CompetitionId;
  eventSlug: string;
  eventId: string;
  inPlay: boolean;
  odds?: Odds;
  handicap?: Handicap;
  marketLevels?: MarketLevels;
  venue?: string;
  deadHeatWinDeductions?: number;
  deadHeatEachwayDeductions?: number;
  eachwayFactor?: Fraction;
  eachwayPlaces?: number;
  eventDescription?: string;
  eventMarketTemplateDescription?: string;
  marketId?: string;
  rule4Deductions?: number;
  selectionId?: SelectionId;
  selectionName?: string;
  sportId?: string;
  startTime?: string;
  marketType?: string;
  priceType?: PriceType;
  raceId?: string;
}

export interface ActiveMeetingBasedMyBetPart {
  eventTypeSlug: string;
  eventTypeId: MeetingBasedEventTypeId;
  meetingId: MeetingId;
  raceId: RaceId;
  venue: string;
  venueSlug: string;
  inPlay: boolean;
  odds?: Odds;
  handicap?: Handicap;
  marketLevels?: MarketLevels;
  deadHeatWinDeductions?: number;
  deadHeatEachwayDeductions?: number;
  eachwayFactor?: Fraction;
  eachwayPlaces?: number;
  eventDescription?: string;
  eventId?: string;
  eventMarketTemplateDescription?: string;
  marketId?: string;
  rule4Deductions?: number;
  selectionId?: SelectionId;
  selectionName?: string;
  sportId?: string;
  startTime?: string;
  marketType?: string;
  priceType?: PriceType;
}

export interface AllMarketGroup {
  templates: MarketTemplate[];
  allMarkets: true;
}

export interface AmericanOdds {
  americanOdds: number;
  americanOddsInt: number;
}

export interface AnimalRaceMetaRequestPayload {
  urlParams: { eventTypeId: string; meetingId: string; raceId: string };
}

export type AntePostEventsHandlerResponseBody = AntePostEventsView;

export interface AntePostEventsTemplateView {
  template: { templateId: 'LINK'; marketId: MarketId };
}

export interface AntePostEventsView {
  markets: Record<string, MarketView>;
  eventTypes: {
    '1'?: EventTypeView;
    '2'?: EventTypeView;
    '3'?: EventTypeView;
    '4'?: EventTypeView;
    '5'?: EventTypeView;
    '6'?: EventTypeView;
    '7'?: EventTypeView;
    '8'?: EventTypeView;
    '10'?: EventTypeView;
    '11'?: EventTypeView;
    '12'?: EventTypeView;
    '1477'?: EventTypeView;
    '3503'?: EventTypeView;
    '3988'?: EventTypeView;
    '4339'?: EventTypeView;
    '6231'?: EventTypeView;
    '6422'?: EventTypeView;
    '6423'?: EventTypeView;
    '7511'?: EventTypeView;
    '7522'?: EventTypeView;
    '7523'?: EventTypeView;
    '7524'?: EventTypeView;
    '61420'?: EventTypeView;
    '72382'?: EventTypeView;
    '136332'?: EventTypeView;
    '300000'?: EventTypeView;
    '315220'?: EventTypeView;
    '451485'?: EventTypeView;
    '468328'?: EventTypeView;
    '606611'?: EventTypeView;
    '620576'?: EventTypeView;
    '627555'?: EventTypeView;
    '678378'?: EventTypeView;
    '982477'?: EventTypeView;
    '998916'?: EventTypeView;
    '998917'?: EventTypeView;
    '998918'?: EventTypeView;
    '998919'?: EventTypeView;
    '998920'?: EventTypeView;
    '1938544'?: EventTypeView;
    '2152880'?: EventTypeView;
    '2378961'?: EventTypeView;
    '2593174'?: EventTypeView;
    '2872194'?: EventTypeView;
    '2901849'?: EventTypeView;
    '3088925'?: EventTypeView;
    '4609466'?: EventTypeView;
    '4726642'?: EventTypeView;
    '5412697'?: EventTypeView;
    '15826206'?: EventTypeView;
    '26420387'?: EventTypeView;
    '27065662'?: EventTypeView;
    '27105927'?: EventTypeView;
    '27388198'?: EventTypeView;
    '27454571'?: EventTypeView;
    '27485048'?: EventTypeView;
    '27589895'?: EventTypeView;
    '28347302'?: EventTypeView;
    '28361982'?: EventTypeView;
    '28578623'?: EventTypeView;
    '28608996'?: EventTypeView;
    '28609007'?: EventTypeView;
    '29125756'?: EventTypeView;
  };
  events: Record<string, AntePostEventView>;
  templateGroups: (
    | AntePostEventsTemplateView[][]
    | AntePostEventsTemplateView[]
    | (AntePostEventsTemplateView[][] & AntePostEventsTemplateView[])
  )[];
}

export interface AntePostEventView {
  eventName: string;
  eventSlug: string;
  eventStartTime: string;
  eventTypeId: MeetingBasedEventTypeId;
  eventId: EventId;
  oddsBoostCount: number;
  isInPlay: boolean;
}

export type AntePostMarketHandlerResponseBody = AntePostMarketView;

export interface AntePostMarketView {
  markets: Record<string, MarketView>;
  eventTypes: {
    '1'?: EventTypeView;
    '2'?: EventTypeView;
    '3'?: EventTypeView;
    '4'?: EventTypeView;
    '5'?: EventTypeView;
    '6'?: EventTypeView;
    '7'?: EventTypeView;
    '8'?: EventTypeView;
    '10'?: EventTypeView;
    '11'?: EventTypeView;
    '12'?: EventTypeView;
    '1477'?: EventTypeView;
    '3503'?: EventTypeView;
    '3988'?: EventTypeView;
    '4339'?: EventTypeView;
    '6231'?: EventTypeView;
    '6422'?: EventTypeView;
    '6423'?: EventTypeView;
    '7511'?: EventTypeView;
    '7522'?: EventTypeView;
    '7523'?: EventTypeView;
    '7524'?: EventTypeView;
    '61420'?: EventTypeView;
    '72382'?: EventTypeView;
    '136332'?: EventTypeView;
    '300000'?: EventTypeView;
    '315220'?: EventTypeView;
    '451485'?: EventTypeView;
    '468328'?: EventTypeView;
    '606611'?: EventTypeView;
    '620576'?: EventTypeView;
    '627555'?: EventTypeView;
    '678378'?: EventTypeView;
    '982477'?: EventTypeView;
    '998916'?: EventTypeView;
    '998917'?: EventTypeView;
    '998918'?: EventTypeView;
    '998919'?: EventTypeView;
    '998920'?: EventTypeView;
    '1938544'?: EventTypeView;
    '2152880'?: EventTypeView;
    '2378961'?: EventTypeView;
    '2593174'?: EventTypeView;
    '2872194'?: EventTypeView;
    '2901849'?: EventTypeView;
    '3088925'?: EventTypeView;
    '4609466'?: EventTypeView;
    '4726642'?: EventTypeView;
    '5412697'?: EventTypeView;
    '15826206'?: EventTypeView;
    '26420387'?: EventTypeView;
    '27065662'?: EventTypeView;
    '27105927'?: EventTypeView;
    '27388198'?: EventTypeView;
    '27454571'?: EventTypeView;
    '27485048'?: EventTypeView;
    '27589895'?: EventTypeView;
    '28347302'?: EventTypeView;
    '28361982'?: EventTypeView;
    '28578623'?: EventTypeView;
    '28608996'?: EventTypeView;
    '28609007'?: EventTypeView;
    '29125756'?: EventTypeView;
  };
  events: Record<string, AntePostEventView>;
  templates: TemplateView[];
}

export interface APIGatewayEventClientCertificate {
  clientCertPem: string;
  serialNumber: string;
  subjectDN: string;
  issuerDN: string;
  validity: { notAfter: string; notBefore: string };
}

export interface APIGatewayEventIdentity {
  accessKey: string | null;
  accountId: string | null;
  apiKey: string | null;
  apiKeyId: string | null;
  caller: string | null;
  clientCert: APIGatewayEventClientCertificate | any;
  cognitoAuthenticationProvider: string | null;
  cognitoAuthenticationType: string | null;
  cognitoIdentityId: string | null;
  cognitoIdentityPoolId: string | null;
  principalOrgId: string | null;
  sourceIp: string;
  user: string | null;
  userAgent: string | null;
  userArn: string | null;
}

export interface APIGatewayEventRequestContextWithAuthorizerAPIGatewayEventDefaultAuthorizerContext {
  accountId: string;
  apiId: string;
  authorizer?: any | object;
  connectedAt?: number;
  connectionId?: string;
  domainName?: string;
  domainPrefix?: string;
  eventType?: string;
  extendedRequestId?: string;
  protocol: string;
  httpMethod: string;
  identity: APIGatewayEventIdentity;
  messageDirection?: string;
  messageId?: string | null;
  path: string;
  stage: string;
  requestId: string;
  requestTime?: string;
  requestTimeEpoch: number;
  resourceId: string;
  resourcePath: string;
  routeKey?: string;
}

/**
 * Works with Lambda Proxy Integration for Rest API or HTTP API integration Payload Format version 1.0
 */
export type APIGatewayProxyEvent = APIGatewayProxyEventBaseAPIGatewayEventDefaultAuthorizerContext;

export interface APIGatewayProxyEventBaseAPIGatewayEventDefaultAuthorizerContext {
  body: string | null;
  headers: APIGatewayProxyEventHeaders;
  multiValueHeaders: APIGatewayProxyEventMultiValueHeaders;
  httpMethod: string;
  isBase64Encoded: boolean;
  path: string;
  pathParameters: APIGatewayProxyEventPathParameters | any;
  queryStringParameters: APIGatewayProxyEventQueryStringParameters | any;
  multiValueQueryStringParameters: APIGatewayProxyEventMultiValueQueryStringParameters | any;
  stageVariables: APIGatewayProxyEventStageVariables | any;
  requestContext: APIGatewayEventRequestContextWithAuthorizerAPIGatewayEventDefaultAuthorizerContext;
  resource: string;
}

export type APIGatewayProxyEventHeaders = Record<string, string | any>;

export type APIGatewayProxyEventMultiValueHeaders = Record<
  string,
  string[] | any | (string[] & any)
>;

export type APIGatewayProxyEventMultiValueQueryStringParameters = Record<
  string,
  string[] | any | (string[] & any)
>;

export type APIGatewayProxyEventPathParameters = Record<string, string | any>;

export type APIGatewayProxyEventQueryStringParameters = Record<string, string | any>;

export type APIGatewayProxyEventStageVariables = Record<string, string | any>;

export interface AvailableCashoutQuote {
  betDelay: number;
  betId: string;
  cashOutToken: string;
  freeSize: number;
  marketStatus: Record<string, MarketStatus>;
  stake: number;
  originalPotentialWin: number;
  partialCashout: {
    partialCashoutQuote: number;
    remainingStake: number;
    remainingStakePerLine: number;
    remainingPotentialReturn: number;
    originalRemainingPotentialReturn: number;
  }[];
  potentialWin: number;
  quote: number;
  quoteStatus: 'AVAILABLE';
  refreshRate: number;
}

export interface AZHandlerResponseBody {
  data: MappedAz;
}

export interface BannerMarket {
  marketId: string;
  inPlay: boolean;
  legTypes: LegTypes;
  marketLevels?: MarketLevels;
  marketName: string;
  marketStatus: MarketStatus;
  runners: Runners;
  turnInPlayEnabled: boolean;
}

export interface BaseMeeting {
  id: MeetingId;
  venue: string;
  venueSlug: string;
  nextRaceId: RaceId;
}

export interface BaseMultipleOpportunity {
  id: string;
  winRunnerOdds?: Odds;
  type: MultipleBetType;
  legCombinations: LegCombination[];
  maxStake: number;
  maxPayout?: number;
  minStake: number;
  minLineStake?: number;
  minStakeIncrement: number;
  returnFactor?: number;
  eachWayMax: number;
  eachWayAvailable: boolean;
  placeReturnFactor?: number;
  numberOfLines: number;
  status: 'AVAILABLE';
  betDelay: number;
  applicableWallets?: ExtraWalletId[];
  hasBonusMoney?: boolean;
  runnersIds: RunnerId[];
  features?: Features;
}

export interface BaseMyBetPart {
  inPlay: boolean;
  odds?: Odds;
  handicap?: Handicap;
  marketLevels?: MarketLevels;
  venue?: string;
  deadHeatWinDeductions?: number;
  deadHeatEachwayDeductions?: number;
  eachwayFactor?: Fraction;
  eachwayPlaces?: number;
  eventDescription?: string;
  eventId?: string;
  eventMarketTemplateDescription?: string;
  marketId?: string;
  rule4Deductions?: number;
  selectionId?: SelectionId;
  selectionName?: string;
  sportId?: string;
  startTime?: string;
  marketType?: string;
  priceType?: PriceType;
  raceId?: string;
}

export interface BaseRace {
  id: RaceId;
  startTime: string;
  meetingId: MeetingId;
  status?: RaceStatus;
}

export enum BetBuildLegType {
  SIMPLE_SELECTION = 'SIMPLE_SELECTION',
  FORECAST = 'FORECAST',
  REVERSE_FORECAST = 'REVERSE_FORECAST',
  COMBINATION_FORECAST = 'COMBINATION_FORECAST',
  TRICAST = 'TRICAST',
  COMBINATION_TRICAST = 'COMBINATION_TRICAST',
  SCORECAST = 'SCORECAST',
  WINCAST = 'WINCAST',
  ONE_LINE_BET = 'ONE_LINE_BET'
}

export enum BetLegType {
  SS = 'SS',
  SF = 'SF',
  RF = 'RF',
  CF = 'CF',
  TC = 'TC',
  CT = 'CT',
  SC = 'SC',
  MH = 'MH',
  WH = 'WH',
  SL = 'SL',
  HL = 'HL',
  FW = 'FW',
  LW = 'LW',
  AW = 'AW'
}

export enum BetType {
  SINGLE = 'SINGLE',
  DOUBLE = 'DOUBLE',
  TREBLE = 'TREBLE',
  FOURFOLD = 'FOURFOLD',
  FIVEFOLD = 'FIVEFOLD',
  SIXFOLD = 'SIXFOLD',
  SEVENFOLD = 'SEVENFOLD',
  EIGHTFOLD = 'EIGHTFOLD',
  NINEFOLD = 'NINEFOLD',
  TENFOLD = 'TENFOLD',
  ELEVENFOLD = 'ELEVENFOLD',
  TWELVEFOLD = 'TWELVEFOLD',
  THIRTEENFOLD = 'THIRTEENFOLD',
  FOURTEENFOLD = 'FOURTEENFOLD',
  FIFTEENFOLD = 'FIFTEENFOLD',
  SIXTEENFOLD = 'SIXTEENFOLD',
  SEVENTEENFOLD = 'SEVENTEENFOLD',
  EIGHTEENFOLD = 'EIGHTEENFOLD',
  NINETEENFOLD = 'NINETEENFOLD',
  TWENTYFOLD = 'TWENTYFOLD',
  TWENTYONEFOLD = 'TWENTYONEFOLD',
  TWENTYTWOFOLD = 'TWENTYTWOFOLD',
  TWENTYTHREEFOLD = 'TWENTYTHREEFOLD',
  TWENTYFOURFOLD = 'TWENTYFOURFOLD',
  TWENTYFIVEFOLD = 'TWENTYFIVEFOLD',
  TRIXIE = 'TRIXIE',
  PATENT = 'PATENT',
  YANKEE = 'YANKEE',
  CANADIAN = 'CANADIAN',
  HEINZ = 'HEINZ',
  SUPER_HEINZ = 'SUPER_HEINZ',
  GOLIATH = 'GOLIATH',
  LUCKY15 = 'LUCKY_15',
  LUCKY31 = 'LUCKY_31',
  LUCKY63 = 'LUCKY_63'
}

export interface BreadcrumbsHandlerResponseBody {
  data: { text?: string };
}

export interface BrowseInPlayForSportHandlerResponseBody {
  data: BrowseInPlayTemplatesView;
}

export interface BrowseInPlayHandlerResponseBody {
  data: BrowseInPlayTemplatesView;
}

export interface BrowseInPlayTemplatesView {
  markets: Record<string, MarketView>;
  eventTypes: {
    '1'?: EventTypeView;
    '2'?: EventTypeView;
    '3'?: EventTypeView;
    '4'?: EventTypeView;
    '5'?: EventTypeView;
    '6'?: EventTypeView;
    '7'?: EventTypeView;
    '8'?: EventTypeView;
    '10'?: EventTypeView;
    '11'?: EventTypeView;
    '12'?: EventTypeView;
    '1477'?: EventTypeView;
    '3503'?: EventTypeView;
    '3988'?: EventTypeView;
    '4339'?: EventTypeView;
    '6231'?: EventTypeView;
    '6422'?: EventTypeView;
    '6423'?: EventTypeView;
    '7511'?: EventTypeView;
    '7522'?: EventTypeView;
    '7523'?: EventTypeView;
    '7524'?: EventTypeView;
    '61420'?: EventTypeView;
    '72382'?: EventTypeView;
    '136332'?: EventTypeView;
    '300000'?: EventTypeView;
    '315220'?: EventTypeView;
    '451485'?: EventTypeView;
    '468328'?: EventTypeView;
    '606611'?: EventTypeView;
    '620576'?: EventTypeView;
    '627555'?: EventTypeView;
    '678378'?: EventTypeView;
    '982477'?: EventTypeView;
    '998916'?: EventTypeView;
    '998917'?: EventTypeView;
    '998918'?: EventTypeView;
    '998919'?: EventTypeView;
    '998920'?: EventTypeView;
    '1938544'?: EventTypeView;
    '2152880'?: EventTypeView;
    '2378961'?: EventTypeView;
    '2593174'?: EventTypeView;
    '2872194'?: EventTypeView;
    '2901849'?: EventTypeView;
    '3088925'?: EventTypeView;
    '4609466'?: EventTypeView;
    '4726642'?: EventTypeView;
    '5412697'?: EventTypeView;
    '15826206'?: EventTypeView;
    '26420387'?: EventTypeView;
    '27065662'?: EventTypeView;
    '27105927'?: EventTypeView;
    '27388198'?: EventTypeView;
    '27454571'?: EventTypeView;
    '27485048'?: EventTypeView;
    '27589895'?: EventTypeView;
    '28347302'?: EventTypeView;
    '28361982'?: EventTypeView;
    '28578623'?: EventTypeView;
    '28608996'?: EventTypeView;
    '28609007'?: EventTypeView;
    '29125756'?: EventTypeView;
  };
  competitions: Record<string, CompetitionView>;
  events: Record<string, EventView>;
  groups: TemplateView[][][];
  tabs: MappedInPlayTabs;
}

export type BvpPassthroughHandlerRequestBody = Record<string, any> | string;

export type BvpPassthroughHandlerResponseBody = any;

export type CashoutQuote =
  | AvailableCashoutQuote
  | SuspendedCashoutQuote
  | UnavailableCashoutQuote
  | PendingCashoutQuote
  | (AvailableCashoutQuote & SuspendedCashoutQuote & UnavailableCashoutQuote & PendingCashoutQuote);

export interface CmsBannerHomeHandlerResponseBody {
  data: (StaticBanner | DynamicBanner | (StaticBanner & DynamicBanner))[];
}

export interface CmsBannerSportHandlerResponseBody {
  data: (StaticBanner | DynamicBanner | (StaticBanner & DynamicBanner))[];
}

export interface CompetitionDynamicBanner {
  eventType: { eventTypeId: EventType; eventTypeName: string; eventTypeSlug: string };
  id: string;
  image: string;
  weight: number;
  type: 'DYNAMIC_BANNER';
  template: 'STANDARD' | 'ODDS_BOOST' | 'BET_BUILDER' | 'REQUEST_A_BET';
  bannerType: 'COMPETITION';
  competition: { competitionId: CompetitionId; competitionName: string; competitionSlug: string };
}

export interface CompetitionEventsHandlerResponseBody {
  data:
    | CompetitionEventsTemplatesView
    | NoEventTypeOrCompetitionResponse
    | (CompetitionEventsTemplatesView & NoEventTypeOrCompetitionResponse);
}

export interface CompetitionEventsTemplatesView {
  markets: Record<string, MarketView>;
  eventTypes: {
    '1'?: EventTypeView;
    '2'?: EventTypeView;
    '3'?: EventTypeView;
    '4'?: EventTypeView;
    '5'?: EventTypeView;
    '6'?: EventTypeView;
    '7'?: EventTypeView;
    '8'?: EventTypeView;
    '10'?: EventTypeView;
    '11'?: EventTypeView;
    '12'?: EventTypeView;
    '1477'?: EventTypeView;
    '3503'?: EventTypeView;
    '3988'?: EventTypeView;
    '4339'?: EventTypeView;
    '6231'?: EventTypeView;
    '6422'?: EventTypeView;
    '6423'?: EventTypeView;
    '7511'?: EventTypeView;
    '7522'?: EventTypeView;
    '7523'?: EventTypeView;
    '7524'?: EventTypeView;
    '61420'?: EventTypeView;
    '72382'?: EventTypeView;
    '136332'?: EventTypeView;
    '300000'?: EventTypeView;
    '315220'?: EventTypeView;
    '451485'?: EventTypeView;
    '468328'?: EventTypeView;
    '606611'?: EventTypeView;
    '620576'?: EventTypeView;
    '627555'?: EventTypeView;
    '678378'?: EventTypeView;
    '982477'?: EventTypeView;
    '998916'?: EventTypeView;
    '998917'?: EventTypeView;
    '998918'?: EventTypeView;
    '998919'?: EventTypeView;
    '998920'?: EventTypeView;
    '1938544'?: EventTypeView;
    '2152880'?: EventTypeView;
    '2378961'?: EventTypeView;
    '2593174'?: EventTypeView;
    '2872194'?: EventTypeView;
    '2901849'?: EventTypeView;
    '3088925'?: EventTypeView;
    '4609466'?: EventTypeView;
    '4726642'?: EventTypeView;
    '5412697'?: EventTypeView;
    '15826206'?: EventTypeView;
    '26420387'?: EventTypeView;
    '27065662'?: EventTypeView;
    '27105927'?: EventTypeView;
    '27388198'?: EventTypeView;
    '27454571'?: EventTypeView;
    '27485048'?: EventTypeView;
    '27589895'?: EventTypeView;
    '28347302'?: EventTypeView;
    '28361982'?: EventTypeView;
    '28578623'?: EventTypeView;
    '28608996'?: EventTypeView;
    '28609007'?: EventTypeView;
    '29125756'?: EventTypeView;
  };
  competitions: Record<string, CompetitionView>;
  events: Record<string, EventView>;
  templateGroups: TemplateView[][][];
  showOutrights: boolean;
  hasInPlayMarkets: boolean;
}

export interface CompetitionGroup {
  competitionIds: CompetitionId[];
  name: string;
}

export type CompetitionId = number;

export interface CompetitionLink {
  eventTypeSlug: string;
  eventTypeId: EventType;
  text: string;
  type: 'COMPETITION';
  competitionSlug: string;
  competitionId: CompetitionId;
}

export interface CompetitionMatchesHandlerResponseBody {
  data: CompetitionMatchesMarketTemplatesView;
}

export interface CompetitionMatchesMarketTemplatesView {
  markets: Record<string, MarketView>;
  eventTypes: {
    '1'?: EventTypeView;
    '2'?: EventTypeView;
    '3'?: EventTypeView;
    '4'?: EventTypeView;
    '5'?: EventTypeView;
    '6'?: EventTypeView;
    '7'?: EventTypeView;
    '8'?: EventTypeView;
    '10'?: EventTypeView;
    '11'?: EventTypeView;
    '12'?: EventTypeView;
    '1477'?: EventTypeView;
    '3503'?: EventTypeView;
    '3988'?: EventTypeView;
    '4339'?: EventTypeView;
    '6231'?: EventTypeView;
    '6422'?: EventTypeView;
    '6423'?: EventTypeView;
    '7511'?: EventTypeView;
    '7522'?: EventTypeView;
    '7523'?: EventTypeView;
    '7524'?: EventTypeView;
    '61420'?: EventTypeView;
    '72382'?: EventTypeView;
    '136332'?: EventTypeView;
    '300000'?: EventTypeView;
    '315220'?: EventTypeView;
    '451485'?: EventTypeView;
    '468328'?: EventTypeView;
    '606611'?: EventTypeView;
    '620576'?: EventTypeView;
    '627555'?: EventTypeView;
    '678378'?: EventTypeView;
    '982477'?: EventTypeView;
    '998916'?: EventTypeView;
    '998917'?: EventTypeView;
    '998918'?: EventTypeView;
    '998919'?: EventTypeView;
    '998920'?: EventTypeView;
    '1938544'?: EventTypeView;
    '2152880'?: EventTypeView;
    '2378961'?: EventTypeView;
    '2593174'?: EventTypeView;
    '2872194'?: EventTypeView;
    '2901849'?: EventTypeView;
    '3088925'?: EventTypeView;
    '4609466'?: EventTypeView;
    '4726642'?: EventTypeView;
    '5412697'?: EventTypeView;
    '15826206'?: EventTypeView;
    '26420387'?: EventTypeView;
    '27065662'?: EventTypeView;
    '27105927'?: EventTypeView;
    '27388198'?: EventTypeView;
    '27454571'?: EventTypeView;
    '27485048'?: EventTypeView;
    '27589895'?: EventTypeView;
    '28347302'?: EventTypeView;
    '28361982'?: EventTypeView;
    '28578623'?: EventTypeView;
    '28608996'?: EventTypeView;
    '28609007'?: EventTypeView;
    '29125756'?: EventTypeView;
  };
  competitions: Record<string, CompetitionView>;
  events: Record<string, EventView>;
  competitionName: string;
  templateGroups: MarketTemplate[][][];
}

export interface CompetitionMetaRequestPayload {
  urlParams: { eventTypeId: string; competitionId: string };
}

export interface CompetitionOutrightsHandlerResponseBody {
  data: MappedCompetitionOutrights;
}

export interface CompetitionsHandlerResponseBody {
  data: MappedCompetitions;
}

export interface CompetitionsQuickSwitcherData {
  competitions: Record<string, CompetitionView>;
  eventTypes: {
    '1'?: EventTypeView;
    '2'?: EventTypeView;
    '3'?: EventTypeView;
    '4'?: EventTypeView;
    '5'?: EventTypeView;
    '6'?: EventTypeView;
    '7'?: EventTypeView;
    '8'?: EventTypeView;
    '10'?: EventTypeView;
    '11'?: EventTypeView;
    '12'?: EventTypeView;
    '1477'?: EventTypeView;
    '3503'?: EventTypeView;
    '3988'?: EventTypeView;
    '4339'?: EventTypeView;
    '6231'?: EventTypeView;
    '6422'?: EventTypeView;
    '6423'?: EventTypeView;
    '7511'?: EventTypeView;
    '7522'?: EventTypeView;
    '7523'?: EventTypeView;
    '7524'?: EventTypeView;
    '61420'?: EventTypeView;
    '72382'?: EventTypeView;
    '136332'?: EventTypeView;
    '300000'?: EventTypeView;
    '315220'?: EventTypeView;
    '451485'?: EventTypeView;
    '468328'?: EventTypeView;
    '606611'?: EventTypeView;
    '620576'?: EventTypeView;
    '627555'?: EventTypeView;
    '678378'?: EventTypeView;
    '982477'?: EventTypeView;
    '998916'?: EventTypeView;
    '998917'?: EventTypeView;
    '998918'?: EventTypeView;
    '998919'?: EventTypeView;
    '998920'?: EventTypeView;
    '1938544'?: EventTypeView;
    '2152880'?: EventTypeView;
    '2378961'?: EventTypeView;
    '2593174'?: EventTypeView;
    '2872194'?: EventTypeView;
    '2901849'?: EventTypeView;
    '3088925'?: EventTypeView;
    '4609466'?: EventTypeView;
    '4726642'?: EventTypeView;
    '5412697'?: EventTypeView;
    '15826206'?: EventTypeView;
    '26420387'?: EventTypeView;
    '27065662'?: EventTypeView;
    '27105927'?: EventTypeView;
    '27388198'?: EventTypeView;
    '27454571'?: EventTypeView;
    '27485048'?: EventTypeView;
    '27589895'?: EventTypeView;
    '28347302'?: EventTypeView;
    '28361982'?: EventTypeView;
    '28578623'?: EventTypeView;
    '28608996'?: EventTypeView;
    '28609007'?: EventTypeView;
    '29125756'?: EventTypeView;
  };
  _type: 'COMPETITIONS';
  items: NonEmptyArrayCompetitionId;
  title: string;
}

export enum CompetitionsV2HandlerPathParameters {
  EventTypeId = 'eventTypeId'
}

export type CompetitionsV2HandlerResponseBody = CompetitionsView;

export interface CompetitionsView {
  eventTypes: {
    '1'?: EventTypeView;
    '2'?: EventTypeView;
    '3'?: EventTypeView;
    '4'?: EventTypeView;
    '5'?: EventTypeView;
    '6'?: EventTypeView;
    '7'?: EventTypeView;
    '8'?: EventTypeView;
    '10'?: EventTypeView;
    '11'?: EventTypeView;
    '12'?: EventTypeView;
    '1477'?: EventTypeView;
    '3503'?: EventTypeView;
    '3988'?: EventTypeView;
    '4339'?: EventTypeView;
    '6231'?: EventTypeView;
    '6422'?: EventTypeView;
    '6423'?: EventTypeView;
    '7511'?: EventTypeView;
    '7522'?: EventTypeView;
    '7523'?: EventTypeView;
    '7524'?: EventTypeView;
    '61420'?: EventTypeView;
    '72382'?: EventTypeView;
    '136332'?: EventTypeView;
    '300000'?: EventTypeView;
    '315220'?: EventTypeView;
    '451485'?: EventTypeView;
    '468328'?: EventTypeView;
    '606611'?: EventTypeView;
    '620576'?: EventTypeView;
    '627555'?: EventTypeView;
    '678378'?: EventTypeView;
    '982477'?: EventTypeView;
    '998916'?: EventTypeView;
    '998917'?: EventTypeView;
    '998918'?: EventTypeView;
    '998919'?: EventTypeView;
    '998920'?: EventTypeView;
    '1938544'?: EventTypeView;
    '2152880'?: EventTypeView;
    '2378961'?: EventTypeView;
    '2593174'?: EventTypeView;
    '2872194'?: EventTypeView;
    '2901849'?: EventTypeView;
    '3088925'?: EventTypeView;
    '4609466'?: EventTypeView;
    '4726642'?: EventTypeView;
    '5412697'?: EventTypeView;
    '15826206'?: EventTypeView;
    '26420387'?: EventTypeView;
    '27065662'?: EventTypeView;
    '27105927'?: EventTypeView;
    '27388198'?: EventTypeView;
    '27454571'?: EventTypeView;
    '27485048'?: EventTypeView;
    '27589895'?: EventTypeView;
    '28347302'?: EventTypeView;
    '28361982'?: EventTypeView;
    '28578623'?: EventTypeView;
    '28608996'?: EventTypeView;
    '28609007'?: EventTypeView;
    '29125756'?: EventTypeView;
  };
  competitions: Record<string, CompetitionViewWithOddsBoostCount>;
  groups: CompetitionGroup[];
  allCompetitionIds: CompetitionId[];
}

export interface CompetitionView {
  competitionName: string;
  competitionSlug: string;
  eventTypeId: EventType;
  competitionId: CompetitionId;
}

export interface CompetitionViewWithOddsBoostCount {
  oddsBoostCount: number;
  competitionName: string;
  competitionSlug: string;
  eventTypeId: EventType;
  competitionId: CompetitionId;
}

export type CompoundMarketTemplate =
  | MarketLevelTableCompoundMarketTemplate
  | EventLevelTableCompoundMarketTemplate
  | (MarketLevelTableCompoundMarketTemplate & EventLevelTableCompoundMarketTemplate);

export type CountryCode = string;

export interface CuratedMarketGroup {
  name: string;
  templates: MarketTemplate[];
  slug: string;
  isSgm: boolean;
}

export interface DecimalOdds {
  decimalOdds: number;
}

export interface DistanceFragment {
  totalFurlongs: number;
  totalMeters: number;
  miles: number;
  furlongs: number;
  yards: number;
}

export enum Duration {
  Type3H = '3H',
  Type12H = '12H',
  Type24H = '24H',
  Type4D = '4D'
}

export enum DurationId {
  Type3H = '3h',
  Type12H = '12h',
  Type24H = '24h',
  Type4D = '4d'
}

export type DynamicBanner =
  | EventTypeDynamicBanner
  | CompetitionDynamicBanner
  | EventDynamicBanner
  | MarketDynamicBanner
  | (EventTypeDynamicBanner & CompetitionDynamicBanner & EventDynamicBanner & MarketDynamicBanner);

export interface EchoEndpointHandlerResponseBody {
  /** Works with Lambda Proxy Integration for Rest API or HTTP API integration Payload Format version 1.0 */
  event: APIGatewayProxyEvent;
  node: { version: string };
}

export interface EventBasedMarketView {
  competitionId?: CompetitionId;
  eventId: EventId;
  eventTypeId: EventType;
  inPlay: boolean;
  legTypes: LegType[];
  marketId: MarketId;
  marketLevels: MarketLevels;
  marketName: string;
  marketStatus: MarketStatus;
  marketTime: string;
  marketType: string;
  meetingId?: MeetingId;
  offeredInPlay: boolean;
  placeTerms?: PlaceTerms;
  raceId?: RaceId;
  runners: Runner[];
  isStartingPriceMarket: boolean;
  isSgmEligible?: boolean;
}

export interface EventDynamicBanner {
  competition: { competitionId: CompetitionId; competitionName: string; competitionSlug: string };
  eventType: { eventTypeId: EventType; eventTypeName: string; eventTypeSlug: string };
  id: string;
  image: string;
  weight: number;
  type: 'DYNAMIC_BANNER';
  template: 'STANDARD' | 'ODDS_BOOST' | 'BET_BUILDER' | 'REQUEST_A_BET';
  bannerType: 'EVENT';
  event: { eventId: EventId; eventName: string; eventSlug: string; eventStartTime: string };
  slug?: string;
}

export type EventId = number;

export interface EventInfo {
  eventId: EventId;
  eventTypeId: EventType;
  name: string;
  inPlay: boolean;
  offeredInPlay: boolean;
  eventTime: string;
}

export interface EventInfoHandlerResponseBody {
  data: EventInfo;
}

export interface EventLevelCompoundMarketTemplateColumnClientConfig {
  marketDirection: 'COLUMN';
  title: string;
  information?: string;
  columnTitles?: Record<string, string>;
  shouldCollapseRunners?: true;
  marketTypeCodes: MarketType[];
}

export enum EventLevelCompoundMarketTemplateId {
  EVENT_TABLE = 'EVENT_TABLE'
}

export enum EventLevelEventTemplateId {
  EVENT_MORE_MARKETS = 'EVENT_MORE_MARKETS'
}

export enum EventLevelMarketTemplateId {
  EVENT_ROW = 'EVENT_ROW',
  EVENT_OUTRIGHT = 'EVENT_OUTRIGHT'
}

export interface EventLevelTableCompoundMarketTemplate {
  templateId: EventLevelCompoundMarketTemplateId;
  marketIds: (MarketId | null)[];
  config: EventLevelCompoundMarketTemplateColumnClientConfig;
}

export interface EventLink {
  competitionSlug: string;
  competitionId: CompetitionId;
  eventTypeSlug: string;
  eventTypeId: EventType;
  text: string;
  type: 'EVENT';
  eventSlug: string;
  eventId: EventId;
}

export interface EventMetaRequestPayload {
  urlParams: { eventTypeId: string; competitionId: string; eventId: string; marketGroup?: string };
}

export interface EventsQuickSwitcherData {
  competitions: Record<string, CompetitionView>;
  events: Record<string, EventView>;
  eventTypes: {
    '1'?: EventTypeView;
    '2'?: EventTypeView;
    '3'?: EventTypeView;
    '4'?: EventTypeView;
    '5'?: EventTypeView;
    '6'?: EventTypeView;
    '7'?: EventTypeView;
    '8'?: EventTypeView;
    '10'?: EventTypeView;
    '11'?: EventTypeView;
    '12'?: EventTypeView;
    '1477'?: EventTypeView;
    '3503'?: EventTypeView;
    '3988'?: EventTypeView;
    '4339'?: EventTypeView;
    '6231'?: EventTypeView;
    '6422'?: EventTypeView;
    '6423'?: EventTypeView;
    '7511'?: EventTypeView;
    '7522'?: EventTypeView;
    '7523'?: EventTypeView;
    '7524'?: EventTypeView;
    '61420'?: EventTypeView;
    '72382'?: EventTypeView;
    '136332'?: EventTypeView;
    '300000'?: EventTypeView;
    '315220'?: EventTypeView;
    '451485'?: EventTypeView;
    '468328'?: EventTypeView;
    '606611'?: EventTypeView;
    '620576'?: EventTypeView;
    '627555'?: EventTypeView;
    '678378'?: EventTypeView;
    '982477'?: EventTypeView;
    '998916'?: EventTypeView;
    '998917'?: EventTypeView;
    '998918'?: EventTypeView;
    '998919'?: EventTypeView;
    '998920'?: EventTypeView;
    '1938544'?: EventTypeView;
    '2152880'?: EventTypeView;
    '2378961'?: EventTypeView;
    '2593174'?: EventTypeView;
    '2872194'?: EventTypeView;
    '2901849'?: EventTypeView;
    '3088925'?: EventTypeView;
    '4609466'?: EventTypeView;
    '4726642'?: EventTypeView;
    '5412697'?: EventTypeView;
    '15826206'?: EventTypeView;
    '26420387'?: EventTypeView;
    '27065662'?: EventTypeView;
    '27105927'?: EventTypeView;
    '27388198'?: EventTypeView;
    '27454571'?: EventTypeView;
    '27485048'?: EventTypeView;
    '27589895'?: EventTypeView;
    '28347302'?: EventTypeView;
    '28361982'?: EventTypeView;
    '28578623'?: EventTypeView;
    '28608996'?: EventTypeView;
    '28609007'?: EventTypeView;
    '29125756'?: EventTypeView;
  };
  _type: 'EVENTS';
  items: NonEmptyArrayEventId[];
  title: string;
}

export interface EventTemplate {
  eventId: EventId;
  templateId: EventLevelEventTemplateId;
}

export type EventType =
  | 6423
  | 3988
  | 61420
  | 627555
  | 1938544
  | 7522
  | 7511
  | 998919
  | 2872194
  | 998918
  | 6
  | 982477
  | 136332
  | 4
  | 300000
  | 27388198
  | 11
  | 28578623
  | 3503
  | 28608996
  | 27454571
  | 6231
  | 3088925
  | 998920
  | 15826206
  | 2152880
  | 468328
  | 7523
  | 7524
  | 678378
  | 3
  | 4339
  | 28347302
  | 7
  | 29125756
  | 8
  | 606611
  | 27589895
  | 72382
  | 315220
  | 1477
  | 5
  | 5412697
  | 2378961
  | 12
  | 28609007
  | 1
  | 10
  | 4609466
  | 6422
  | 620576
  | 2593174
  | 2
  | 27065662
  | 4726642
  | 998917
  | 2901849
  | 26420387
  | 28361982
  | 451485
  | 27105927
  | 27485048
  | 998916;

export interface EventTypeDynamicBanner {
  id: string;
  image: string;
  weight: number;
  type: 'DYNAMIC_BANNER';
  template: 'STANDARD' | 'ODDS_BOOST' | 'BET_BUILDER' | 'REQUEST_A_BET';
  bannerType: 'EVENT_TYPE';
  eventType: { eventTypeId: EventType; eventTypeName: string; eventTypeSlug: string };
}

export interface EventTypeInfo {
  eventTypeName: string;
  tabs: TabConfig[];
}

export interface EventTypeInfoHandlerResponseBody {
  data: EventTypeInfo;
}

export interface EventTypeLink {
  text: string;
  type: 'EVENT_TYPE';
  eventTypeSlug: string;
  eventTypeId: EventType;
}

export interface EventTypeMetaRequestPayload {
  urlParams: { eventTypeId: string };
}

export type EventTypeSpecialsHandlerResponseBody = EventTypeSpecialsView;

export interface EventTypeSpecialsView {
  markets: Record<string, MarketView>;
  eventTypes: {
    '1'?: EventTypeView;
    '2'?: EventTypeView;
    '3'?: EventTypeView;
    '4'?: EventTypeView;
    '5'?: EventTypeView;
    '6'?: EventTypeView;
    '7'?: EventTypeView;
    '8'?: EventTypeView;
    '10'?: EventTypeView;
    '11'?: EventTypeView;
    '12'?: EventTypeView;
    '1477'?: EventTypeView;
    '3503'?: EventTypeView;
    '3988'?: EventTypeView;
    '4339'?: EventTypeView;
    '6231'?: EventTypeView;
    '6422'?: EventTypeView;
    '6423'?: EventTypeView;
    '7511'?: EventTypeView;
    '7522'?: EventTypeView;
    '7523'?: EventTypeView;
    '7524'?: EventTypeView;
    '61420'?: EventTypeView;
    '72382'?: EventTypeView;
    '136332'?: EventTypeView;
    '300000'?: EventTypeView;
    '315220'?: EventTypeView;
    '451485'?: EventTypeView;
    '468328'?: EventTypeView;
    '606611'?: EventTypeView;
    '620576'?: EventTypeView;
    '627555'?: EventTypeView;
    '678378'?: EventTypeView;
    '982477'?: EventTypeView;
    '998916'?: EventTypeView;
    '998917'?: EventTypeView;
    '998918'?: EventTypeView;
    '998919'?: EventTypeView;
    '998920'?: EventTypeView;
    '1938544'?: EventTypeView;
    '2152880'?: EventTypeView;
    '2378961'?: EventTypeView;
    '2593174'?: EventTypeView;
    '2872194'?: EventTypeView;
    '2901849'?: EventTypeView;
    '3088925'?: EventTypeView;
    '4609466'?: EventTypeView;
    '4726642'?: EventTypeView;
    '5412697'?: EventTypeView;
    '15826206'?: EventTypeView;
    '26420387'?: EventTypeView;
    '27065662'?: EventTypeView;
    '27105927'?: EventTypeView;
    '27388198'?: EventTypeView;
    '27454571'?: EventTypeView;
    '27485048'?: EventTypeView;
    '27589895'?: EventTypeView;
    '28347302'?: EventTypeView;
    '28361982'?: EventTypeView;
    '28578623'?: EventTypeView;
    '28608996'?: EventTypeView;
    '28609007'?: EventTypeView;
    '29125756'?: EventTypeView;
  };
  competitions: Record<string, CompetitionView>;
  events: Record<string, EventView>;
  templateGroups: (TemplateView[] | TemplateView[][] | (TemplateView[] & TemplateView[][]))[];
}

export interface EventTypeView {
  eventTypeId: EventType;
  eventTypeSlug: string;
  name: string;
}

export interface EventView {
  eventName: string;
  eventSlug: string;
  eventStartTime: string;
  eventTypeId: EventType;
  competitionId: CompetitionId;
  eventId: EventId;
  oddsBoostCount: number;
  isInPlay: boolean;
}

export interface ExtraWallet {
  walletId: ExtraWalletId;

  /** ======================================== Place Bets ======================================== */
  type: WalletTypeEnum;
  amount: number;
  redeemable?: boolean;
  nonRedeemableAmount?: number;
  label?: string;
}

export type ExtraWalletId = number;

export type FcqPassthroughHandlerRequestBody = Record<string, any> | string;

export type FcqPassthroughHandlerResponseBody = any;

export enum Feature {
  SGM = 'SGM',
  SGM_MULTIPLES = 'SGM_MULTIPLES'
}

export interface FeaturedFiltersHandlerResponseBody {
  data: MappedFeaturedFilter[];
}

export type Features = NonEmptyArrayFeature;

export interface Fraction {
  numerator: number;
  denominator: number;
}

export interface FractionalOdds {
  numerator: number;
  denominator: number;
}

export enum Going {
  ALL_WEATHER = 'ALL_WEATHER',
  DEAD = 'DEAD',
  EASY = 'EASY',
  FAST = 'FAST',
  FIRM = 'FIRM',
  FROZEN = 'FROZEN',
  GOOD = 'GOOD',
  GOOD_FIRM = 'GOOD_FIRM',
  GOOD_SOFT = 'GOOD_SOFT',
  HARD = 'HARD',
  HEAVY = 'HEAVY',
  MUDDY = 'MUDDY',
  NORMAL = 'NORMAL',
  RAIN = 'RAIN',
  SAND = 'SAND',
  SLOPPY = 'SLOPPY',
  SLOW = 'SLOW',
  SOFT = 'SOFT',
  STANDARD = 'STANDARD',
  STD = 'STD',
  STD_FAST = 'STD_FAST',
  STD_SLOW = 'STD_SLOW',
  SYNTHETIC = 'SYNTHETIC',
  WET_FAST = 'WET_FAST',
  YIELDING = 'YIELDING'
}

export type Handicap = number;

export interface HomeInPlayHandlerResponseBody {
  data: HomeInPlayTemplatesView;
}

export interface HomeInPlayTab {
  name: string;
  eventTypeId: EventType;
  groups: TemplateView[][][];
}

export interface HomeInPlayTemplatesView {
  markets: Record<string, MarketView>;
  eventTypes: {
    '1'?: EventTypeView;
    '2'?: EventTypeView;
    '3'?: EventTypeView;
    '4'?: EventTypeView;
    '5'?: EventTypeView;
    '6'?: EventTypeView;
    '7'?: EventTypeView;
    '8'?: EventTypeView;
    '10'?: EventTypeView;
    '11'?: EventTypeView;
    '12'?: EventTypeView;
    '1477'?: EventTypeView;
    '3503'?: EventTypeView;
    '3988'?: EventTypeView;
    '4339'?: EventTypeView;
    '6231'?: EventTypeView;
    '6422'?: EventTypeView;
    '6423'?: EventTypeView;
    '7511'?: EventTypeView;
    '7522'?: EventTypeView;
    '7523'?: EventTypeView;
    '7524'?: EventTypeView;
    '61420'?: EventTypeView;
    '72382'?: EventTypeView;
    '136332'?: EventTypeView;
    '300000'?: EventTypeView;
    '315220'?: EventTypeView;
    '451485'?: EventTypeView;
    '468328'?: EventTypeView;
    '606611'?: EventTypeView;
    '620576'?: EventTypeView;
    '627555'?: EventTypeView;
    '678378'?: EventTypeView;
    '982477'?: EventTypeView;
    '998916'?: EventTypeView;
    '998917'?: EventTypeView;
    '998918'?: EventTypeView;
    '998919'?: EventTypeView;
    '998920'?: EventTypeView;
    '1938544'?: EventTypeView;
    '2152880'?: EventTypeView;
    '2378961'?: EventTypeView;
    '2593174'?: EventTypeView;
    '2872194'?: EventTypeView;
    '2901849'?: EventTypeView;
    '3088925'?: EventTypeView;
    '4609466'?: EventTypeView;
    '4726642'?: EventTypeView;
    '5412697'?: EventTypeView;
    '15826206'?: EventTypeView;
    '26420387'?: EventTypeView;
    '27065662'?: EventTypeView;
    '27105927'?: EventTypeView;
    '27388198'?: EventTypeView;
    '27454571'?: EventTypeView;
    '27485048'?: EventTypeView;
    '27589895'?: EventTypeView;
    '28347302'?: EventTypeView;
    '28361982'?: EventTypeView;
    '28578623'?: EventTypeView;
    '28608996'?: EventTypeView;
    '28609007'?: EventTypeView;
    '29125756'?: EventTypeView;
  };
  competitions: Record<string, CompetitionView>;
  events: Record<string, EventView>;
  tabs: HomeInPlayTab[];
}

/**
 * ======================================== Imply Bets ========================================
 */
export enum ImplyRunnerFailureCode {
  INVALID_GLOBAL_MARKET_ID = 'INVALID_GLOBAL_MARKET_ID',
  INVALID_SELECTION_ID = 'INVALID_SELECTION_ID',
  BET_TYPE_NOT_SUPPORTED = 'BET_TYPE_NOT_SUPPORTED',
  MARKET_NOT_FOUND = 'MARKET_NOT_FOUND',
  SELECTION_NOT_FOUND = 'SELECTION_NOT_FOUND',
  SELECTION_NOT_AVAILABLE_INPLAY = 'SELECTION_NOT_AVAILABLE_INPLAY',
  MARKET_SUSPENDED = 'MARKET_SUSPENDED',
  RUNNER_SUSPENDED = 'RUNNER_SUSPENDED',
  REQUESTED_PRICE_NOT_AVAILABLE = 'REQUESTED_PRICE_NOT_AVAILABLE',
  REQUESTED_HANDICAP_NOT_AVAILABLE = 'REQUESTED_HANDICAP_NOT_AVAILABLE',
  INVALID_COMBINATION = 'INVALID_COMBINATION',
  INVALID_SGM_COMBINATION = 'INVALID_SGM_COMBINATION',
  IMPOSSIBLE_SAME_MARKET_COMBINATION = 'IMPOSSIBLE_SAME_MARKET_COMBINATION',
  NOT_ELIGIBLE_SGM_SELECTION = 'NOT_ELIGIBLE_SGM_SELECTION',
  INVALID_SGM_COMBINATION_SINGLE_ODDS = 'INVALID_SGM_COMBINATION_SINGLE_ODDS',
  DUPLICATE_RUNNER = 'DUPLICATE_RUNNER',
  INVALID_LEG = 'INVALID_LEG',
  SELECTION_BLOCKED_FOR_USER_COUNTRY = 'SELECTION_BLOCKED_FOR_USER_COUNTRY',
  INVALID_TEASER_COMBINATION = 'INVALID_TEASER_COMBINATION',
  TEASER_PRICE_NOT_AVAILABLE = 'TEASER_PRICE_NOT_AVAILABLE'
}

export interface InPlayMarketTemplatesView {
  markets: Record<string, MarketView>;
  eventTypes: {
    '1'?: EventTypeView;
    '2'?: EventTypeView;
    '3'?: EventTypeView;
    '4'?: EventTypeView;
    '5'?: EventTypeView;
    '6'?: EventTypeView;
    '7'?: EventTypeView;
    '8'?: EventTypeView;
    '10'?: EventTypeView;
    '11'?: EventTypeView;
    '12'?: EventTypeView;
    '1477'?: EventTypeView;
    '3503'?: EventTypeView;
    '3988'?: EventTypeView;
    '4339'?: EventTypeView;
    '6231'?: EventTypeView;
    '6422'?: EventTypeView;
    '6423'?: EventTypeView;
    '7511'?: EventTypeView;
    '7522'?: EventTypeView;
    '7523'?: EventTypeView;
    '7524'?: EventTypeView;
    '61420'?: EventTypeView;
    '72382'?: EventTypeView;
    '136332'?: EventTypeView;
    '300000'?: EventTypeView;
    '315220'?: EventTypeView;
    '451485'?: EventTypeView;
    '468328'?: EventTypeView;
    '606611'?: EventTypeView;
    '620576'?: EventTypeView;
    '627555'?: EventTypeView;
    '678378'?: EventTypeView;
    '982477'?: EventTypeView;
    '998916'?: EventTypeView;
    '998917'?: EventTypeView;
    '998918'?: EventTypeView;
    '998919'?: EventTypeView;
    '998920'?: EventTypeView;
    '1938544'?: EventTypeView;
    '2152880'?: EventTypeView;
    '2378961'?: EventTypeView;
    '2593174'?: EventTypeView;
    '2872194'?: EventTypeView;
    '2901849'?: EventTypeView;
    '3088925'?: EventTypeView;
    '4609466'?: EventTypeView;
    '4726642'?: EventTypeView;
    '5412697'?: EventTypeView;
    '15826206'?: EventTypeView;
    '26420387'?: EventTypeView;
    '27065662'?: EventTypeView;
    '27105927'?: EventTypeView;
    '27388198'?: EventTypeView;
    '27454571'?: EventTypeView;
    '27485048'?: EventTypeView;
    '27589895'?: EventTypeView;
    '28347302'?: EventTypeView;
    '28361982'?: EventTypeView;
    '28578623'?: EventTypeView;
    '28608996'?: EventTypeView;
    '28609007'?: EventTypeView;
    '29125756'?: EventTypeView;
  };
  competitions: Record<string, CompetitionView>;
  events: Record<string, EventView>;
  groups: TemplateView[][][];
}

export interface InvalidSgmOpportunity {
  id: string;
  runnersIds: RunnerId[];
  numberOfLines: number;
  features: Features;
  sgmData: SgmData[];
  type?:
    | 'DOUBLE'
    | 'TREBLE'
    | 'FOURFOLD'
    | 'FIVEFOLD'
    | 'SIXFOLD'
    | 'SEVENFOLD'
    | 'EIGHTFOLD'
    | 'NINEFOLD'
    | 'TENFOLD'
    | 'ELEVENFOLD'
    | 'TWELVEFOLD'
    | 'THIRTEENFOLD'
    | 'FOURTEENFOLD'
    | 'FIFTEENFOLD'
    | 'SIXTEENFOLD'
    | 'SEVENTEENFOLD'
    | 'EIGHTEENFOLD'
    | 'NINETEENFOLD'
    | 'TWENTYFOLD'
    | 'TWENTYONEFOLD'
    | 'TWENTYTWOFOLD'
    | 'TWENTYTHREEFOLD'
    | 'TWENTYFOURFOLD'
    | 'TWENTYFIVEFOLD'
    | 'TRIXIE'
    | 'PATENT'
    | 'YANKEE'
    | 'CANADIAN'
    | 'HEINZ'
    | 'SUPER_HEINZ'
    | 'GOLIATH'
    | 'LUCKY_15'
    | 'LUCKY_31'
    | 'LUCKY_63';
  status: 'UNAVAILABLE';

  /** ======================================== Imply Bets ======================================== */
  failureCode: ImplyRunnerFailureCode;
}

export interface LegacyCompetitionGroup {
  groupName: string;
  competitions: CompetitionId[];
}

export interface LegacyCompetitionView {
  id: CompetitionId;
  name: string;
  eventTypeSlug: string;
  eventTypeId: EventType;
  competitionSlug: string;
  competitionId: number;
  oddsBoostCount?: number;
}

export enum LegacyDurationId {
  Type3H = '3H',
  Type12H = '12H',
  Type24H = '24H',
  Type4D = '4D'
}

export enum LegBetType {
  Win = 'Win',
  Place = 'Place',
  Eachway = 'Eachway'
}

export interface LegCombination {
  legType: BetBuildLegType;
  runners?: LegRunner[];
}

export interface LegRunner {
  marketId: MarketId;
  selectionId: SelectionId;
  handicap?: Handicap;
}

export enum LegType {
  SIMPLE_SELECTION = 'SIMPLE_SELECTION',
  FORECAST = 'FORECAST',
  REVERSE_FORECAST = 'REVERSE_FORECAST',
  COMBINATION_FORECAST = 'COMBINATION_FORECAST',
  TRICAST = 'TRICAST',
  COMBINATION_TRICAST = 'COMBINATION_TRICAST',
  SCORECAST = 'SCORECAST',
  WINCAST = 'WINCAST'
}

export type LegTypes = LegType[];

export type LinkItem =
  | EventTypeLink
  | CompetitionLink
  | EventLink
  | (EventTypeLink & CompetitionLink & EventLink);

export interface LinksHandlerResponseBody {
  data: MappedLinks;
}

export interface MappedAnimalRaceMetaData {
  eventTypeSlug: string;
  startTime: string;
  venue: string;
  venueSlug: string;
  meetingId: MeetingId;
  raceId: RaceId;
}

export type MappedAz = EventTypeLink[];

export interface MappedCompetitionMetaData {
  competitionId: CompetitionId;
  competitionName: string;
  competitionSlug: string;
  eventTypeId: EventType;
  eventTypeName: string;
  eventTypeSlug: string;
}

export interface MappedCompetitionOutrights {
  outrights: OutrightView[];
  competitionName: string;
  showEvents: boolean;
  showMatches: boolean;
}

export interface MappedCompetitions {
  groups: LegacyCompetitionGroup[];
  competitions: Record<string, LegacyCompetitionView>;
}

export interface MappedEventMetaData {
  eventTypeId: EventType;
  eventTypeSlug: string;
  eventTypeName: string;
  competitionId: CompetitionId;
  competitionSlug: string;
  competitionName: string;
  eventId: EventId;
  eventSlug: string;
  eventName: string;
  marketGroup?: string;
}

export interface MappedEventTypeMetaData {
  eventTypeId: EventType;
  eventTypeSlug: string;
  eventTypeName: string;
  popularCompetitions: string;
}

export interface MappedFeaturedFilter {
  eventTypeId: EventType;
  eventTypeSlug: string;
  name: string;
  params: { duration: Duration; market: string };
}

export type MappedInPlayTabs = {
  name: string;
  eventTypeId: EventType;
  eventTypeSlug: string;
  count: number;
}[];

export type MappedLinks = LinkItem[];

export interface MappedMarketMetaData {
  eventTypeSlug: string;
  eventSlug: string;
  marketSlug: string;
  marketId: MarketId;
  marketName: string;
}

export type MappedMyBets = MyBet[];

export interface MappedNextRaces {
  markets: Record<string, MeetingBasedMarketView>;
  eventTypes: {
    '1'?: EventTypeView;
    '2'?: EventTypeView;
    '3'?: EventTypeView;
    '4'?: EventTypeView;
    '5'?: EventTypeView;
    '6'?: EventTypeView;
    '7'?: EventTypeView;
    '8'?: EventTypeView;
    '10'?: EventTypeView;
    '11'?: EventTypeView;
    '12'?: EventTypeView;
    '1477'?: EventTypeView;
    '3503'?: EventTypeView;
    '3988'?: EventTypeView;
    '4339'?: EventTypeView;
    '6231'?: EventTypeView;
    '6422'?: EventTypeView;
    '6423'?: EventTypeView;
    '7511'?: EventTypeView;
    '7522'?: EventTypeView;
    '7523'?: EventTypeView;
    '7524'?: EventTypeView;
    '61420'?: EventTypeView;
    '72382'?: EventTypeView;
    '136332'?: EventTypeView;
    '300000'?: EventTypeView;
    '315220'?: EventTypeView;
    '451485'?: EventTypeView;
    '468328'?: EventTypeView;
    '606611'?: EventTypeView;
    '620576'?: EventTypeView;
    '627555'?: EventTypeView;
    '678378'?: EventTypeView;
    '982477'?: EventTypeView;
    '998916'?: EventTypeView;
    '998917'?: EventTypeView;
    '998918'?: EventTypeView;
    '998919'?: EventTypeView;
    '998920'?: EventTypeView;
    '1938544'?: EventTypeView;
    '2152880'?: EventTypeView;
    '2378961'?: EventTypeView;
    '2593174'?: EventTypeView;
    '2872194'?: EventTypeView;
    '2901849'?: EventTypeView;
    '3088925'?: EventTypeView;
    '4609466'?: EventTypeView;
    '4726642'?: EventTypeView;
    '5412697'?: EventTypeView;
    '15826206'?: EventTypeView;
    '26420387'?: EventTypeView;
    '27065662'?: EventTypeView;
    '27105927'?: EventTypeView;
    '27388198'?: EventTypeView;
    '27454571'?: EventTypeView;
    '27485048'?: EventTypeView;
    '27589895'?: EventTypeView;
    '28347302'?: EventTypeView;
    '28361982'?: EventTypeView;
    '28578623'?: EventTypeView;
    '28608996'?: EventTypeView;
    '28609007'?: EventTypeView;
    '29125756'?: EventTypeView;
  };
  meetings: Record<string, MeetingView>;
  races: Record<string, RaceView>;
  templates: Template[];
}

export interface MappedPopularMetaData {
  popularEventTypes: string;
}

export interface MappedRaceCard {
  markets: Record<string, MeetingBasedMarketView>;
  eventTypes: {
    '1'?: EventTypeView;
    '2'?: EventTypeView;
    '3'?: EventTypeView;
    '4'?: EventTypeView;
    '5'?: EventTypeView;
    '6'?: EventTypeView;
    '7'?: EventTypeView;
    '8'?: EventTypeView;
    '10'?: EventTypeView;
    '11'?: EventTypeView;
    '12'?: EventTypeView;
    '1477'?: EventTypeView;
    '3503'?: EventTypeView;
    '3988'?: EventTypeView;
    '4339'?: EventTypeView;
    '6231'?: EventTypeView;
    '6422'?: EventTypeView;
    '6423'?: EventTypeView;
    '7511'?: EventTypeView;
    '7522'?: EventTypeView;
    '7523'?: EventTypeView;
    '7524'?: EventTypeView;
    '61420'?: EventTypeView;
    '72382'?: EventTypeView;
    '136332'?: EventTypeView;
    '300000'?: EventTypeView;
    '315220'?: EventTypeView;
    '451485'?: EventTypeView;
    '468328'?: EventTypeView;
    '606611'?: EventTypeView;
    '620576'?: EventTypeView;
    '627555'?: EventTypeView;
    '678378'?: EventTypeView;
    '982477'?: EventTypeView;
    '998916'?: EventTypeView;
    '998917'?: EventTypeView;
    '998918'?: EventTypeView;
    '998919'?: EventTypeView;
    '998920'?: EventTypeView;
    '1938544'?: EventTypeView;
    '2152880'?: EventTypeView;
    '2378961'?: EventTypeView;
    '2593174'?: EventTypeView;
    '2872194'?: EventTypeView;
    '2901849'?: EventTypeView;
    '3088925'?: EventTypeView;
    '4609466'?: EventTypeView;
    '4726642'?: EventTypeView;
    '5412697'?: EventTypeView;
    '15826206'?: EventTypeView;
    '26420387'?: EventTypeView;
    '27065662'?: EventTypeView;
    '27105927'?: EventTypeView;
    '27388198'?: EventTypeView;
    '27454571'?: EventTypeView;
    '27485048'?: EventTypeView;
    '27589895'?: EventTypeView;
    '28347302'?: EventTypeView;
    '28361982'?: EventTypeView;
    '28578623'?: EventTypeView;
    '28608996'?: EventTypeView;
    '28609007'?: EventTypeView;
    '29125756'?: EventTypeView;
  };
  meetings: Record<string, MeetingView>;
  races: Record<string, RaceView>;
  templates: MarketTemplate[];
  timeformRunners?: string[];
}

export interface MappedRaceMeetings {
  meetings: Record<string, BaseMeeting>;
  races: Record<string, BaseRace>;
  templateGroups: MeetingGroupWithDate[][];
}

export interface MappedRacePage {
  markets: Record<string, MeetingBasedMarketView>;
  eventTypes: {
    '1'?: EventTypeView;
    '2'?: EventTypeView;
    '3'?: EventTypeView;
    '4'?: EventTypeView;
    '5'?: EventTypeView;
    '6'?: EventTypeView;
    '7'?: EventTypeView;
    '8'?: EventTypeView;
    '10'?: EventTypeView;
    '11'?: EventTypeView;
    '12'?: EventTypeView;
    '1477'?: EventTypeView;
    '3503'?: EventTypeView;
    '3988'?: EventTypeView;
    '4339'?: EventTypeView;
    '6231'?: EventTypeView;
    '6422'?: EventTypeView;
    '6423'?: EventTypeView;
    '7511'?: EventTypeView;
    '7522'?: EventTypeView;
    '7523'?: EventTypeView;
    '7524'?: EventTypeView;
    '61420'?: EventTypeView;
    '72382'?: EventTypeView;
    '136332'?: EventTypeView;
    '300000'?: EventTypeView;
    '315220'?: EventTypeView;
    '451485'?: EventTypeView;
    '468328'?: EventTypeView;
    '606611'?: EventTypeView;
    '620576'?: EventTypeView;
    '627555'?: EventTypeView;
    '678378'?: EventTypeView;
    '982477'?: EventTypeView;
    '998916'?: EventTypeView;
    '998917'?: EventTypeView;
    '998918'?: EventTypeView;
    '998919'?: EventTypeView;
    '998920'?: EventTypeView;
    '1938544'?: EventTypeView;
    '2152880'?: EventTypeView;
    '2378961'?: EventTypeView;
    '2593174'?: EventTypeView;
    '2872194'?: EventTypeView;
    '2901849'?: EventTypeView;
    '3088925'?: EventTypeView;
    '4609466'?: EventTypeView;
    '4726642'?: EventTypeView;
    '5412697'?: EventTypeView;
    '15826206'?: EventTypeView;
    '26420387'?: EventTypeView;
    '27065662'?: EventTypeView;
    '27105927'?: EventTypeView;
    '27388198'?: EventTypeView;
    '27454571'?: EventTypeView;
    '27485048'?: EventTypeView;
    '27589895'?: EventTypeView;
    '28347302'?: EventTypeView;
    '28361982'?: EventTypeView;
    '28578623'?: EventTypeView;
    '28608996'?: EventTypeView;
    '28609007'?: EventTypeView;
    '29125756'?: EventTypeView;
  };
  meetings: Record<string, MeetingView>;
  races: Record<string, RaceView>;
  templates: MarketTemplate[];
  timeformRunners?: string[];
}

export interface MarketDynamicBanner {
  event: { eventId: EventId; eventName: string; eventSlug: string; eventStartTime: string };
  slug?: string;
  competition: { competitionId: CompetitionId; competitionName: string; competitionSlug: string };
  eventType: { eventTypeId: EventType; eventTypeName: string; eventTypeSlug: string };
  id: string;
  image: string;
  weight: number;
  type: 'DYNAMIC_BANNER';
  template: 'STANDARD' | 'ODDS_BOOST' | 'BET_BUILDER' | 'REQUEST_A_BET';
  bannerType: 'MARKET';
  market: BannerMarket;
}

export interface MarketFilter {
  text: string;
  value: MarketType;
}

export type MarketId = string;

export enum MarketLevel {
  AVB_EVENT = 'AVB_EVENT',
  COMPETITION = 'COMPETITION',
  SUB_COMPETITION = 'SUB_COMPETITION',
  UNKNOWN = 'UNKNOWN'
}

export interface MarketLevelCompoundMarketTemplateColumnClientConfig {
  marketDirection: 'COLUMN';
  title: string;
  information?: string;
  columnTitles?: Record<string, string>;
  shouldCollapseRunners?: true;
  marketTypeCodes: MarketType[];
}

export enum MarketLevelCompoundMarketTemplateId {
  TABLE = 'TABLE'
}

export interface MarketLevelCompoundMarketTemplateRowConfig {
  marketDirection: 'ROW';
  title: string;
  columnTitles: string[];
}

export enum MarketLevelMarketTemplateId {
  GRID = 'GRID',
  LIST = 'LIST',
  ROW = 'ROW',
  TIMED_LIST = 'TIMED_LIST',
  ODDS_BOOST = 'ODDS_BOOST',
  NAMED_LIST = 'NAMED_LIST',
  RACE_CARD = 'RACE_CARD',
  LINK = 'LINK',
  ANTE_POST_LIST = 'ANTE_POST_LIST'
}

export type MarketLevels = MarketLevel[];

export interface MarketLevelTableCompoundMarketTemplate {
  templateId: MarketLevelCompoundMarketTemplateId;
  marketIds: (MarketId | null)[];
  config:
    | MarketLevelCompoundMarketTemplateRowConfig
    | MarketLevelCompoundMarketTemplateColumnClientConfig
    | (MarketLevelCompoundMarketTemplateRowConfig &
        MarketLevelCompoundMarketTemplateColumnClientConfig);
}

export interface MarketMetaRequestPayload {
  urlParams: { eventTypeId: string; marketId: string };
}

export interface MarketsHandlerResponseBody {
  data: MarketsMarketTemplatesView;
}

export interface MarketsMarketTemplatesView {
  markets: Record<string, MarketView>;
  eventTypes: {
    '1'?: EventTypeView;
    '2'?: EventTypeView;
    '3'?: EventTypeView;
    '4'?: EventTypeView;
    '5'?: EventTypeView;
    '6'?: EventTypeView;
    '7'?: EventTypeView;
    '8'?: EventTypeView;
    '10'?: EventTypeView;
    '11'?: EventTypeView;
    '12'?: EventTypeView;
    '1477'?: EventTypeView;
    '3503'?: EventTypeView;
    '3988'?: EventTypeView;
    '4339'?: EventTypeView;
    '6231'?: EventTypeView;
    '6422'?: EventTypeView;
    '6423'?: EventTypeView;
    '7511'?: EventTypeView;
    '7522'?: EventTypeView;
    '7523'?: EventTypeView;
    '7524'?: EventTypeView;
    '61420'?: EventTypeView;
    '72382'?: EventTypeView;
    '136332'?: EventTypeView;
    '300000'?: EventTypeView;
    '315220'?: EventTypeView;
    '451485'?: EventTypeView;
    '468328'?: EventTypeView;
    '606611'?: EventTypeView;
    '620576'?: EventTypeView;
    '627555'?: EventTypeView;
    '678378'?: EventTypeView;
    '982477'?: EventTypeView;
    '998916'?: EventTypeView;
    '998917'?: EventTypeView;
    '998918'?: EventTypeView;
    '998919'?: EventTypeView;
    '998920'?: EventTypeView;
    '1938544'?: EventTypeView;
    '2152880'?: EventTypeView;
    '2378961'?: EventTypeView;
    '2593174'?: EventTypeView;
    '2872194'?: EventTypeView;
    '2901849'?: EventTypeView;
    '3088925'?: EventTypeView;
    '4609466'?: EventTypeView;
    '4726642'?: EventTypeView;
    '5412697'?: EventTypeView;
    '15826206'?: EventTypeView;
    '26420387'?: EventTypeView;
    '27065662'?: EventTypeView;
    '27105927'?: EventTypeView;
    '27388198'?: EventTypeView;
    '27454571'?: EventTypeView;
    '27485048'?: EventTypeView;
    '27589895'?: EventTypeView;
    '28347302'?: EventTypeView;
    '28361982'?: EventTypeView;
    '28578623'?: EventTypeView;
    '28608996'?: EventTypeView;
    '28609007'?: EventTypeView;
    '29125756'?: EventTypeView;
  };
  competitions: Record<string, CompetitionView>;
  events: Record<string, EventView>;
  groups: (CuratedMarketGroup | AllMarketGroup | (CuratedMarketGroup & AllMarketGroup))[];
  hasInPlayMarkets: boolean;
}

export enum MarketStatus {
  OPEN = 'OPEN',
  ACTIVE = 'ACTIVE',
  INACTIVE = 'INACTIVE',
  SUSPENDED = 'SUSPENDED',
  CLOSED = 'CLOSED'
}

export enum MarketStatusReason {
  LATE_WITHDRAWAL = 'LATE_WITHDRAWAL',
  INPLAY_COUNTRY_NOT_ELIGIBLE = 'INPLAY_COUNTRY_NOT_ELIGIBLE'
}

export type MarketsUpdatesHandlerRequestBody = MarketUpdatesRequestPayload;

export type MarketsUpdatesHandlerResponseBody = MappedMarketsUpdates;

export type MarketTemplate =
  | SingleMarketTemplate
  | CompoundMarketTemplate
  | (SingleMarketTemplate & CompoundMarketTemplate);

export type MarketType = string;

export interface MarketUpdate {
  marketId: MarketId;
  marketStatus: MarketStatus;
  legTypes?: LegType[];
  runners: RunnerUpdate[];
}

export type MarketUpdatesRequestPayload = MarketId[];

export type MarketView =
  | EventBasedMarketView
  | MeetingBasedMarketView
  | (EventBasedMarketView & MeetingBasedMarketView);

export enum MatchFilterHandlerPathParameters {
  EventTypeId = 'eventTypeId'
}

export type MatchFilterHandlerResponseBody = MatchFilterResponse;

export interface MatchFilterResponse {
  markets: Record<string, MarketView>;
  eventTypes: {
    '1'?: EventTypeView;
    '2'?: EventTypeView;
    '3'?: EventTypeView;
    '4'?: EventTypeView;
    '5'?: EventTypeView;
    '6'?: EventTypeView;
    '7'?: EventTypeView;
    '8'?: EventTypeView;
    '10'?: EventTypeView;
    '11'?: EventTypeView;
    '12'?: EventTypeView;
    '1477'?: EventTypeView;
    '3503'?: EventTypeView;
    '3988'?: EventTypeView;
    '4339'?: EventTypeView;
    '6231'?: EventTypeView;
    '6422'?: EventTypeView;
    '6423'?: EventTypeView;
    '7511'?: EventTypeView;
    '7522'?: EventTypeView;
    '7523'?: EventTypeView;
    '7524'?: EventTypeView;
    '61420'?: EventTypeView;
    '72382'?: EventTypeView;
    '136332'?: EventTypeView;
    '300000'?: EventTypeView;
    '315220'?: EventTypeView;
    '451485'?: EventTypeView;
    '468328'?: EventTypeView;
    '606611'?: EventTypeView;
    '620576'?: EventTypeView;
    '627555'?: EventTypeView;
    '678378'?: EventTypeView;
    '982477'?: EventTypeView;
    '998916'?: EventTypeView;
    '998917'?: EventTypeView;
    '998918'?: EventTypeView;
    '998919'?: EventTypeView;
    '998920'?: EventTypeView;
    '1938544'?: EventTypeView;
    '2152880'?: EventTypeView;
    '2378961'?: EventTypeView;
    '2593174'?: EventTypeView;
    '2872194'?: EventTypeView;
    '2901849'?: EventTypeView;
    '3088925'?: EventTypeView;
    '4609466'?: EventTypeView;
    '4726642'?: EventTypeView;
    '5412697'?: EventTypeView;
    '15826206'?: EventTypeView;
    '26420387'?: EventTypeView;
    '27065662'?: EventTypeView;
    '27105927'?: EventTypeView;
    '27388198'?: EventTypeView;
    '27454571'?: EventTypeView;
    '27485048'?: EventTypeView;
    '27589895'?: EventTypeView;
    '28347302'?: EventTypeView;
    '28361982'?: EventTypeView;
    '28578623'?: EventTypeView;
    '28608996'?: EventTypeView;
    '28609007'?: EventTypeView;
    '29125756'?: EventTypeView;
  };
  competitions: Record<string, CompetitionView>;
  events: Record<string, EventView>;
  filters: TranslatedFilters;
  templateGroups: TemplateView[][][];
}

export enum MatchFilterV2HandlerPathParameters {
  EventTypeId = 'eventTypeId'
}

export type MatchFilterV2HandlerResponseBody = MatchFilterResponse;

export type MeetingBasedEventTypeId = 7 | 4339 | (7 & 4339);

export interface MeetingBasedMarketView {
  competitionId?: CompetitionId;
  eventId: EventId;
  eventTypeId: MeetingBasedEventTypeId;
  inPlay: boolean;
  legTypes: LegType[];
  marketId: MarketId;
  marketLevels: MarketLevels;
  marketName: string;
  marketStatus: MarketStatus;
  marketTime: string;
  marketType: string;
  meetingId: MeetingId;
  offeredInPlay: boolean;
  placeTerms?: PlaceTerms;
  raceId: RaceId;
  runners: MeetingBasedRunner[];
  isStartingPriceMarket: boolean;
  isSgmEligible?: boolean;
}

export interface MeetingBasedRunner {
  handicap?: Handicap;
  previousWinRunnerOdds: Odds[];
  runnerName: string;
  runnerStatus?: RunnerStatusMarketDetails;
  selectionId: SelectionId;
  sortPriority: number;
  winRunnerOdds?: Odds;
  resultType?: RunnerResultType;
  details?: RichContentRunnerDetails;
  comments?: string;
  ratingStars?: number;
  rating123?: number;
  form?: string;
  rating?: number;
  daysOff?: number;
  horse?: { age?: number };
}

export interface MeetingGroupWithDate {
  name: RegionName;
  meetingIds: MeetingId[];
  date: string;
}

export type MeetingId = string;

export interface MeetingsQuickSwitcherData {
  meetings: Record<string, MeetingView>;
  races: Record<string, RaceView>;
  eventTypes: {
    '1'?: EventTypeView;
    '2'?: EventTypeView;
    '3'?: EventTypeView;
    '4'?: EventTypeView;
    '5'?: EventTypeView;
    '6'?: EventTypeView;
    '7'?: EventTypeView;
    '8'?: EventTypeView;
    '10'?: EventTypeView;
    '11'?: EventTypeView;
    '12'?: EventTypeView;
    '1477'?: EventTypeView;
    '3503'?: EventTypeView;
    '3988'?: EventTypeView;
    '4339'?: EventTypeView;
    '6231'?: EventTypeView;
    '6422'?: EventTypeView;
    '6423'?: EventTypeView;
    '7511'?: EventTypeView;
    '7522'?: EventTypeView;
    '7523'?: EventTypeView;
    '7524'?: EventTypeView;
    '61420'?: EventTypeView;
    '72382'?: EventTypeView;
    '136332'?: EventTypeView;
    '300000'?: EventTypeView;
    '315220'?: EventTypeView;
    '451485'?: EventTypeView;
    '468328'?: EventTypeView;
    '606611'?: EventTypeView;
    '620576'?: EventTypeView;
    '627555'?: EventTypeView;
    '678378'?: EventTypeView;
    '982477'?: EventTypeView;
    '998916'?: EventTypeView;
    '998917'?: EventTypeView;
    '998918'?: EventTypeView;
    '998919'?: EventTypeView;
    '998920'?: EventTypeView;
    '1938544'?: EventTypeView;
    '2152880'?: EventTypeView;
    '2378961'?: EventTypeView;
    '2593174'?: EventTypeView;
    '2872194'?: EventTypeView;
    '2901849'?: EventTypeView;
    '3088925'?: EventTypeView;
    '4609466'?: EventTypeView;
    '4726642'?: EventTypeView;
    '5412697'?: EventTypeView;
    '15826206'?: EventTypeView;
    '26420387'?: EventTypeView;
    '27065662'?: EventTypeView;
    '27105927'?: EventTypeView;
    '27388198'?: EventTypeView;
    '27454571'?: EventTypeView;
    '27485048'?: EventTypeView;
    '27589895'?: EventTypeView;
    '28347302'?: EventTypeView;
    '28361982'?: EventTypeView;
    '28578623'?: EventTypeView;
    '28608996'?: EventTypeView;
    '28609007'?: EventTypeView;
    '29125756'?: EventTypeView;
  };
  _type: 'MEETINGS';
  firstOffRaceId: RaceId;
  groups: RaceId[][];
  header: RegionName;
}

export interface MeetingView {
  venue: string;
  venueSlug: string;
  eventTypeId: EventType;
  meetingId: MeetingId;
}

export type MetaAnimalRaceHandlerRequestBody = AnimalRaceMetaRequestPayload;

export type MetaAnimalRaceHandlerResponseBody = ResponsePayloadMappedAnimalRaceMetaData;

export type MetaCompetitionHandlerRequestBody = CompetitionMetaRequestPayload;

export type MetaCompetitionHandlerResponseBody = ResponsePayloadMappedCompetitionMetaData;

export type MetaEventHandlerRequestBody = EventMetaRequestPayload;

export type MetaEventHandlerResponseBody = ResponsePayloadMappedEventMetaData;

export type MetaEventTypeHandlerRequestBody = EventTypeMetaRequestPayload;

export type MetaEventTypeHandlerResponseBody = ResponsePayloadMappedEventTypeMetaData;

export type MetaMarketHandlerRequestBody = MarketMetaRequestPayload;

export type MetaMarketHandlerResponseBody = ResponsePayloadMappedMarketMetaData;

export type MetaPopularHandlerResponseBody = ResponsePayloadMappedPopularMetaData;

export type MultipleAvailableOpportunity =
  | BaseMultipleOpportunity
  | SgmOpportunity
  | (BaseMultipleOpportunity & SgmOpportunity);

export enum MultipleBetType {
  DOUBLE = 'DOUBLE',
  TREBLE = 'TREBLE',
  FOURFOLD = 'FOURFOLD',
  FIVEFOLD = 'FIVEFOLD',
  SIXFOLD = 'SIXFOLD',
  SEVENFOLD = 'SEVENFOLD',
  EIGHTFOLD = 'EIGHTFOLD',
  NINEFOLD = 'NINEFOLD',
  TENFOLD = 'TENFOLD',
  ELEVENFOLD = 'ELEVENFOLD',
  TWELVEFOLD = 'TWELVEFOLD',
  THIRTEENFOLD = 'THIRTEENFOLD',
  FOURTEENFOLD = 'FOURTEENFOLD',
  FIFTEENFOLD = 'FIFTEENFOLD',
  SIXTEENFOLD = 'SIXTEENFOLD',
  SEVENTEENFOLD = 'SEVENTEENFOLD',
  EIGHTEENFOLD = 'EIGHTEENFOLD',
  NINETEENFOLD = 'NINETEENFOLD',
  TWENTYFOLD = 'TWENTYFOLD',
  TWENTYONEFOLD = 'TWENTYONEFOLD',
  TWENTYTWOFOLD = 'TWENTYTWOFOLD',
  TWENTYTHREEFOLD = 'TWENTYTHREEFOLD',
  TWENTYFOURFOLD = 'TWENTYFOURFOLD',
  TWENTYFIVEFOLD = 'TWENTYFIVEFOLD',
  TRIXIE = 'TRIXIE',
  PATENT = 'PATENT',
  YANKEE = 'YANKEE',
  CANADIAN = 'CANADIAN',
  HEINZ = 'HEINZ',
  SUPER_HEINZ = 'SUPER_HEINZ',
  GOLIATH = 'GOLIATH',
  LUCKY15 = 'LUCKY_15',
  LUCKY31 = 'LUCKY_31',
  LUCKY63 = 'LUCKY_63'
}

export type MultipleOpportunity =
  | MultipleAvailableOpportunity
  | InvalidSgmOpportunity
  | (MultipleAvailableOpportunity & InvalidSgmOpportunity);

export interface MyBet {
  actualWin?: number;
  betId: string;
  betReceiptId: string;
  betType: BetType;
  currency: Currency;
  eachwayPlaces?: number;
  eachwayFactor?: Fraction;
  isSettled: boolean;
  legs: MyBetLeg[];
  legBetType: LegBetType;
  numLines: number;
  odds?: Odds;
  walletInfo: WalletInfo;
  placedDate: string;
  potentialWin?: string;
  regulatorId?: string;
  result?: ResultType;
  sgmResult?: SgmResultType;
  isSgm?: boolean;
  stake?: number;
  stakePerLine?: number;
  status: string;
  settledDate?: string;
  sgmEvents?: MyBetSgmEvent[];
}

export interface MyBetLeg {
  legType: BetLegType;
  result?: ResultType;
  parts: MyBetPart[];
}

export type MyBetPart =
  | BaseMyBetPart
  | ActiveEventBasedMyBetPart
  | ActiveMeetingBasedMyBetPart
  | ActiveAntePostBasedMyBetPart
  | (BaseMyBetPart &
      ActiveEventBasedMyBetPart &
      ActiveMeetingBasedMyBetPart &
      ActiveAntePostBasedMyBetPart);

export interface MyBetSgmEvent {
  eventId: string;
  eventDescription?: string;
  startTime?: string;
  legType: BetLegType;
  inPlay: boolean;
  parts: SgmPart[];
  eventTypeId: number;
}

export type MyBetsHandlerRequestBody = MyBetsRequest;

export type MyBetsHandlerResponseBody = MyBetsResponse;

export type MyBetsRequest = SearchBetsQuery;

export interface MyBetsResponse {
  accountId?: number;
  currencyCode?: string;
  localeCode?: string;
  numberOfMatches?: number;
  moreAvailable?: boolean;
  bets: MappedMyBets;
  cashoutQuotes: Record<string, CashoutQuote>;
}

export interface NextRacesHandlerResponseBody {
  data: MappedNextRaces;
}

export interface NoEventTypeOrCompetitionResponse {
  showOutrights: boolean;
}

export type NonEmptyArrayCompetitionId = CompetitionId[];

export type NonEmptyArrayEventId = EventId[];

export type NonEmptyArrayFeature = Feature[];

export interface Odds {
  americanDisplayOdds?: AmericanOdds;
  decimalDisplayOdds?: DecimalOdds;
  fractionalDisplayOdds?: FractionalOdds;
  trueOdds: TrueOdds;
}

export interface OddsBoostHandlerResponseBody {
  data: OddsBoostMarketTemplatesView;
}

export interface OddsBoostMarketTemplatesView {
  markets: Record<string, MarketView>;
  eventTypes: {
    '1'?: EventTypeView;
    '2'?: EventTypeView;
    '3'?: EventTypeView;
    '4'?: EventTypeView;
    '5'?: EventTypeView;
    '6'?: EventTypeView;
    '7'?: EventTypeView;
    '8'?: EventTypeView;
    '10'?: EventTypeView;
    '11'?: EventTypeView;
    '12'?: EventTypeView;
    '1477'?: EventTypeView;
    '3503'?: EventTypeView;
    '3988'?: EventTypeView;
    '4339'?: EventTypeView;
    '6231'?: EventTypeView;
    '6422'?: EventTypeView;
    '6423'?: EventTypeView;
    '7511'?: EventTypeView;
    '7522'?: EventTypeView;
    '7523'?: EventTypeView;
    '7524'?: EventTypeView;
    '61420'?: EventTypeView;
    '72382'?: EventTypeView;
    '136332'?: EventTypeView;
    '300000'?: EventTypeView;
    '315220'?: EventTypeView;
    '451485'?: EventTypeView;
    '468328'?: EventTypeView;
    '606611'?: EventTypeView;
    '620576'?: EventTypeView;
    '627555'?: EventTypeView;
    '678378'?: EventTypeView;
    '982477'?: EventTypeView;
    '998916'?: EventTypeView;
    '998917'?: EventTypeView;
    '998918'?: EventTypeView;
    '998919'?: EventTypeView;
    '998920'?: EventTypeView;
    '1938544'?: EventTypeView;
    '2152880'?: EventTypeView;
    '2378961'?: EventTypeView;
    '2593174'?: EventTypeView;
    '2872194'?: EventTypeView;
    '2901849'?: EventTypeView;
    '3088925'?: EventTypeView;
    '4609466'?: EventTypeView;
    '4726642'?: EventTypeView;
    '5412697'?: EventTypeView;
    '15826206'?: EventTypeView;
    '26420387'?: EventTypeView;
    '27065662'?: EventTypeView;
    '27105927'?: EventTypeView;
    '27388198'?: EventTypeView;
    '27454571'?: EventTypeView;
    '27485048'?: EventTypeView;
    '27589895'?: EventTypeView;
    '28347302'?: EventTypeView;
    '28361982'?: EventTypeView;
    '28578623'?: EventTypeView;
    '28608996'?: EventTypeView;
    '28609007'?: EventTypeView;
    '29125756'?: EventTypeView;
  };
  competitions: Record<string, CompetitionView>;
  events: Record<string, EventView>;
  groups: MarketId[][];
}

export interface Opportunities {
  SINGLE: SingleOpportunity[];
  MULTIPLE: MultipleOpportunity[];
}

export type OpportunitiesHandlerRequestBody = OpportunityRequestPayload;

export type OpportunitiesHandlerResponseBody = OpportunitiesResponse;

export interface OpportunitiesResponse {
  opportunities: Opportunities;
  wallets: Record<string, ExtraWallet>;
  hasInvalidCombination: boolean;
  dailyMaxPayoutLimit?: number;
  requiredPlacementCurrency?: Currency;
}

export interface OpportunityRequest {
  eventId: EventId;
  legType: BetBuildLegType;
  marketId: MarketId;
  selectionId: SelectionId;
}

export type OpportunityRequestPayload = OpportunityRequest[];

export interface OutrightMarket {
  id: MarketId;
  label: string;
  marketStatus: MarketStatus;
  placeTerms?: PlaceTerms;
  runners: Runner[];
  legTypes?: LegType[];
  marketType: string;
}

export interface OutrightView {
  id: EventId;
  name: string;
  markets: OutrightMarket[];
  eventStartTime: string;
}

export interface PendingCashoutQuote {
  betId: string;
  stake: number;
  potentialWin: number;
  originalPotentialWin: number;
  freeSize: number;
  marketStatus: Record<string, MarketStatus>;
  refreshRate: number;
  quoteStatus:
    | 'UNAVAILABLE'
    | 'BET_CLOSED'
    | 'NOT_ELIGIBLE'
    | 'QUOTE_TOO_LOW'
    | 'QUOTE_TOO_LOW_FREE_BET'
    | 'LEG_RESULT_PENDING'
    | 'PENDING_CASHOUT';
  quoteStatusReason: QuoteStatusReason[];
  marketStatusReason: Record<string, MarketStatusReason>;
}

export interface PlaceTerms {
  numPlaces: number;
  deductionFraction: string;
}

export enum PriceType {
  LIVE = 'LIVE',
  STARTING = 'STARTING',
  GUARANTEED = 'GUARANTEED',
  DIVIDEND = 'DIVIDEND'
}

export enum QueryType {
  ALL_NO_TEXT = 'ALL_NO_TEXT'
}

export type QuickSwitcherData =
  | EventsQuickSwitcherData
  | MeetingsQuickSwitcherData
  | CompetitionsQuickSwitcherData
  | (EventsQuickSwitcherData & MeetingsQuickSwitcherData & CompetitionsQuickSwitcherData);

export enum QuickSwitcherHandlerPathParameters {
  FacetId = 'facetId',
  HierarchyLevel = 'hierarchyLevel'
}

export type QuickSwitcherHandlerResponseBody = QuickSwitcherData;

export enum QuoteStatusReason {
  LATE_WITHDRAWAL = 'LATE_WITHDRAWAL',
  INPLAY_COUNTRY_NOT_ELIGIBLE = 'INPLAY_COUNTRY_NOT_ELIGIBLE',
  ACCOUNT_NOT_ACTIVE = 'ACCOUNT_NOT_ACTIVE'
}

export interface RaceAttachment {
  key?: string;
  raceId: RaceId;
  winMarketId: MeetingId;
  winMarketName?: string;
  userStartTime?: string;
  startTime: string;
  eventTypeId: EventType;
  eventId: EventId;
  countryCode?: CountryCode;
  timezone?: string;
  venue: string;
  videoAvailable?: boolean;
  meetingId: MeetingId;
  raceNumber?: string;
  raceType?: string;
  onTvChannels?: string[];
  raceClass?: string;
}

export interface RaceCardHandlerResponseBody {
  data: MappedRaceCard;
}

export interface RaceDetailsFragment {
  raceClass?: number;
  type?: RaceType;
  going?: Going;
  status?: RaceStatus;
  distance: DistanceFragment;
}

export type RaceId = string;

export interface RaceInfo {
  races: Record<string, RaceAttachment>;
}

export interface RaceInfoHandlerResponseBody {
  data: RaceInfo;
}

export interface RaceMeetingsHandlerResponseBody {
  data: MappedRaceMeetings;
}

export interface RacePageHandlerResponseBody {
  data: MappedRacePage;
}

export enum RaceStatus {
  ABANDONED = 'ABANDONED',
  AT_THE_POST = 'AT_THE_POST',
  DELAYED = 'DELAYED',
  DORMANT = 'DORMANT',
  FALSE_START = 'FALSE_START',
  FINISHED = 'FINISHED',
  GOING_BEHIND = 'GOING_BEHIND',
  GOING_DOWN = 'GOING_DOWN',
  OFF = 'OFF',
  PARADING = 'PARADING',
  PHOTOGRAPH = 'PHOTOGRAPH',
  RACE_VOID = 'RACE_VOID',
  RESULT = 'RESULT',
  UNDER_ORDERS = 'UNDER_ORDERS',
  WEIGHED_IN = 'WEIGHED_IN'
}

export enum RaceType {
  BUMPER = 'BUMPER',
  CHASE = 'CHASE',
  FLAT = 'FLAT',
  HURDLE = 'HURDLE'
}

export interface RaceView {
  key?: string;
  raceId: RaceId;
  winMarketId: MeetingId;
  winMarketName?: string;
  userStartTime?: string;
  startTime: string;
  eventTypeId: EventType;
  eventId: EventId;
  countryCode?: CountryCode;
  timezone?: string;
  venue: string;
  videoAvailable?: boolean;
  meetingId: MeetingId;
  raceNumber?: string;
  raceType?: string;
  onTvChannels?: string[];
  raceClass?: string;
  details?: RichContentRaceDetails;
  verdict?: string;
}

export enum RegionName {
  ISPI18NUKXIRELAND = 'ISP_I18N_UK_X_IRELAND',
  ISPI18NINTERNATIONAL = 'ISP_I18N_INTERNATIONAL'
}

export interface ResponsePayloadMappedAnimalRaceMetaData {
  tokens: Record<string, MappedAnimalRaceMetaData>;
}

export interface ResponsePayloadMappedCompetitionMetaData {
  tokens: Record<string, MappedCompetitionMetaData>;
}

export interface ResponsePayloadMappedEventMetaData {
  tokens: Record<string, MappedEventMetaData>;
}

export interface ResponsePayloadMappedEventTypeMetaData {
  tokens: Record<string, MappedEventTypeMetaData>;
}

export interface ResponsePayloadMappedMarketMetaData {
  tokens: Record<string, MappedMarketMetaData>;
}

export interface ResponsePayloadMappedPopularMetaData {
  tokens: Record<string, MappedPopularMetaData>;
}

export enum ResultType {
  WON = 'WON',
  PLACED = 'PLACED',
  LOST = 'LOST',
  VOID = 'VOID',
  SETTLED = 'SETTLED',
  CASHED_OUT = 'CASHED_OUT'
}

export type RichContentRaceDetails = RaceDetailsFragment;

export type RichContentRunnerDetails = RunnerDetailsFragment;

export interface Runner {
  handicap?: Handicap;
  previousWinRunnerOdds: Odds[];
  runnerName: string;
  runnerStatus?: RunnerStatusMarketDetails;
  selectionId: SelectionId;
  sortPriority: number;
  winRunnerOdds?: Odds;
  resultType?: RunnerResultType;
}

export interface RunnerDetailsFragment {
  equipmentDescription?: string;
  silk?: any;
  saddleCloth: string;
  jockeyName?: string;
  trainerName?: string;
  weight?: { stones: string };
}

export interface RunnerId {
  marketId: MarketId;
  selectionId: SelectionId;
}

export enum RunnerResultType {
  HOME = 'HOME',
  AWAY = 'AWAY',
  DRAW = 'DRAW',
  OVER = 'OVER',
  UNDER = 'UNDER',
  LINE = 'LINE',
  SCORE = 'SCORE',
  NO_GOAL = 'NO_GOAL'
}

export type Runners = Runner[];

export enum RunnerStatus {
  ACTIVE = 'ACTIVE',
  WINNER = 'WINNER',
  LOSER = 'LOSER',
  REMOVE_VACANT = 'REMOVE_VACANT',
  REMOVED = 'REMOVED'
}

export enum RunnerStatusMarketDetails {
  ACTIVE = 'ACTIVE',
  SUSPENDED = 'SUSPENDED',
  REMOVED = 'REMOVED'
}

export interface RunnerUpdate {
  handicap?: Handicap;
  previousWinRunnerOdds: Odds[];
  runnerId: RunnerId;
  runnerStatus?:
    | RunnerStatusMarketDetails
    | RunnerStatus
    | (RunnerStatusMarketDetails & RunnerStatus);
  winRunnerOdds?: Odds;
}

export type ScanPassthroughHandlerRequestBody = Record<string, any> | string;

export type ScanPassthroughHandlerResponseBody = any;

export type ScaPassthroughHandlerRequestBody = Record<string, any> | string;

export type ScaPassthroughHandlerResponseBody = any;

export type ScoPassthroughHandlerRequestBody = Record<string, any> | string;

export type ScoPassthroughHandlerResponseBody = any;

export interface SearchBetsQuery {
  betIds?: string[];
  marketIds?: string[];
  isSettled?: boolean;
  placedAfter?: string;
  placedBefore?: string;
  settledAfter?: string;
  settledBefore?: string;
  sortDir: SortDirType;
  sortParam?: SortParamType;
  fromRecord?: number;
  toRecord?: number;
  locale?: string;
  queryTypes?: QueryType[];
  eventIds?: string[];
}

export type SelectionId = number;

export interface SgmData {
  eventId: number;
  eventTypeId: EventType;
  eventName: string;
  eventStartTime: string;
  descriptions: SgmDescription[];
}

export interface SgmDescription {
  isValid: boolean;
  marketName: string;
  runnerName: string;
}

export interface SgmOpportunity {
  id: string;
  winRunnerOdds?: Odds;
  type: MultipleBetType;
  legCombinations: LegCombination[];
  maxStake: number;
  maxPayout?: number;
  minStake: number;
  minLineStake?: number;
  minStakeIncrement: number;
  returnFactor?: number;
  eachWayMax: number;
  eachWayAvailable: boolean;
  placeReturnFactor?: number;
  numberOfLines: number;
  status: 'AVAILABLE';
  betDelay: number;
  applicableWallets?: ExtraWalletId[];
  hasBonusMoney?: boolean;
  runnersIds: RunnerId[];
  features: Features;
  sgmData: SgmData[];
}

export type SgmPart =
  | {
      result?: ResultType;
      inPlay: boolean;
      odds?: Odds;
      handicap?: Handicap;
      marketLevels?: MarketLevels;
      venue?: string;
      deadHeatWinDeductions?: number;
      deadHeatEachwayDeductions?: number;
      eachwayFactor?: Fraction;
      eachwayPlaces?: number;
      eventDescription?: string;
      eventId?: string;
      eventMarketTemplateDescription?: string;
      marketId?: string;
      rule4Deductions?: number;
      selectionId?: SelectionId;
      selectionName?: string;
      sportId?: string;
      startTime?: string;
      marketType?: string;
      priceType?: PriceType;
    }
  | {
      result?: ResultType;
      eventTypeSlug: string;
      eventTypeId: EventType;
      competitionSlug: string;
      competitionId: CompetitionId;
      eventSlug: string;
      eventId: string;
      inPlay: boolean;
      odds?: Odds;
      handicap?: Handicap;
      marketLevels?: MarketLevels;
      venue?: string;
      deadHeatWinDeductions?: number;
      deadHeatEachwayDeductions?: number;
      eachwayFactor?: Fraction;
      eachwayPlaces?: number;
      eventDescription?: string;
      eventMarketTemplateDescription?: string;
      marketId?: string;
      rule4Deductions?: number;
      selectionId?: SelectionId;
      selectionName?: string;
      sportId?: string;
      startTime?: string;
      marketType?: string;
      priceType?: PriceType;
    }
  | {
      result?: ResultType;
      eventTypeSlug: string;
      eventTypeId: MeetingBasedEventTypeId;
      meetingId: MeetingId;
      raceId: RaceId;
      venue: string;
      venueSlug: string;
      inPlay: boolean;
      odds?: Odds;
      handicap?: Handicap;
      marketLevels?: MarketLevels;
      deadHeatWinDeductions?: number;
      deadHeatEachwayDeductions?: number;
      eachwayFactor?: Fraction;
      eachwayPlaces?: number;
      eventDescription?: string;
      eventId?: string;
      eventMarketTemplateDescription?: string;
      marketId?: string;
      rule4Deductions?: number;
      selectionId?: SelectionId;
      selectionName?: string;
      sportId?: string;
      startTime?: string;
      marketType?: string;
      priceType?: PriceType;
    }
  | {
      result?: ResultType;
      eventTypeId: EventType;
      marketType: 'ANTEPOST_WIN';
      deadHeatWinDeductions?: number;
      deadHeatEachwayDeductions?: number;
      eachwayFactor?: Fraction;
      eachwayPlaces?: number;
      eventDescription?: string;
      eventId?: string;
      eventMarketTemplateDescription?: string;
      marketId?: string;
      rule4Deductions?: number;
      selectionId?: SelectionId;
      selectionName?: string;
      sportId?: string;
      startTime?: string;
      priceType?: PriceType;
      inPlay: boolean;
      odds?: Odds;
      handicap?: Handicap;
      marketLevels?: MarketLevels;
      venue?: string;
      eventTypeSlug: string;
      eventSlug: string;
    }
  | ({
      result?: ResultType;
      inPlay: boolean;
      odds?: Odds;
      handicap?: Handicap;
      marketLevels?: MarketLevels;
      venue?: string;
      deadHeatWinDeductions?: number;
      deadHeatEachwayDeductions?: number;
      eachwayFactor?: Fraction;
      eachwayPlaces?: number;
      eventDescription?: string;
      eventId?: string;
      eventMarketTemplateDescription?: string;
      marketId?: string;
      rule4Deductions?: number;
      selectionId?: SelectionId;
      selectionName?: string;
      sportId?: string;
      startTime?: string;
      marketType?: string;
      priceType?: PriceType;
    } & {
      result?: ResultType;
      eventTypeSlug: string;
      eventTypeId: EventType;
      competitionSlug: string;
      competitionId: CompetitionId;
      eventSlug: string;
      eventId: string;
      inPlay: boolean;
      odds?: Odds;
      handicap?: Handicap;
      marketLevels?: MarketLevels;
      venue?: string;
      deadHeatWinDeductions?: number;
      deadHeatEachwayDeductions?: number;
      eachwayFactor?: Fraction;
      eachwayPlaces?: number;
      eventDescription?: string;
      eventMarketTemplateDescription?: string;
      marketId?: string;
      rule4Deductions?: number;
      selectionId?: SelectionId;
      selectionName?: string;
      sportId?: string;
      startTime?: string;
      marketType?: string;
      priceType?: PriceType;
    } & {
      result?: ResultType;
      eventTypeSlug: string;
      eventTypeId: MeetingBasedEventTypeId;
      meetingId: MeetingId;
      raceId: RaceId;
      venue: string;
      venueSlug: string;
      inPlay: boolean;
      odds?: Odds;
      handicap?: Handicap;
      marketLevels?: MarketLevels;
      deadHeatWinDeductions?: number;
      deadHeatEachwayDeductions?: number;
      eachwayFactor?: Fraction;
      eachwayPlaces?: number;
      eventDescription?: string;
      eventId?: string;
      eventMarketTemplateDescription?: string;
      marketId?: string;
      rule4Deductions?: number;
      selectionId?: SelectionId;
      selectionName?: string;
      sportId?: string;
      startTime?: string;
      marketType?: string;
      priceType?: PriceType;
    } & {
      result?: ResultType;
      eventTypeId: EventType;
      marketType: 'ANTEPOST_WIN';
      deadHeatWinDeductions?: number;
      deadHeatEachwayDeductions?: number;
      eachwayFactor?: Fraction;
      eachwayPlaces?: number;
      eventDescription?: string;
      eventId?: string;
      eventMarketTemplateDescription?: string;
      marketId?: string;
      rule4Deductions?: number;
      selectionId?: SelectionId;
      selectionName?: string;
      sportId?: string;
      startTime?: string;
      priceType?: PriceType;
      inPlay: boolean;
      odds?: Odds;
      handicap?: Handicap;
      marketLevels?: MarketLevels;
      venue?: string;
      eventTypeSlug: string;
      eventSlug: string;
    });

export enum SgmResultType {
  WON = 'WON',
  PLACED = 'PLACED',
  LOST = 'LOST',
  VOID = 'VOID'
}

export type SibPassthroughHandlerRequestBody = Record<string, any> | string;

export type SibPassthroughHandlerResponseBody = any;

export interface SingleAvailableOpportunity {
  id: string;
  winRunnerOdds?: Odds;
  type: 'SINGLE';
  legCombinations: LegCombination[];
  maxStake: number;
  maxPayout?: number;
  minStake: number;
  minLineStake?: number;
  minStakeIncrement: number;
  returnFactor?: number;
  eachWayMax: number;
  eachWayAvailable: boolean;
  placeReturnFactor?: number;
  numberOfLines: number;
  status: 'AVAILABLE';
  betDelay: number;
  applicableWallets?: ExtraWalletId[];
  hasBonusMoney?: boolean;
  name: string;
  eventId: EventId;
  runnerId: RunnerId;
  description: string;
  eventInPlay: boolean;
  eventTypeId: EventType;
  eventStartTime: string;
  handicap: Handicap;
  runnerResultType?: RunnerResultType;
  placeTerms?: PlaceTerms;
  marketTime: string;
  marketType: MarketType;
  venue?: string;
  isStartingPriceOpportunity: boolean;
  competitionId: CompetitionId;
  raceId?: string;
}

export interface SingleMarketTemplate {
  templateId:
    | MarketLevelMarketTemplateId
    | EventLevelMarketTemplateId
    | (MarketLevelMarketTemplateId & EventLevelMarketTemplateId);
  marketId: MarketId;
}

export type SingleOpportunity =
  | SingleAvailableOpportunity
  | SingleUnavailableOpportunity
  | (SingleAvailableOpportunity & SingleUnavailableOpportunity);

export interface SingleUnavailableOpportunity {
  id: string;
  eventId: EventId;
  type: 'SINGLE';
  status: 'UNAVAILABLE' | 'SUSPENDED';
  runnerId: RunnerId;
  name?: string;
  description?: string;
  eventTypeId?: EventType;
  failureCode?: string;
  competitionId?: CompetitionId;
}

export type SmpPassthroughHandlerRequestBody = Record<string, any> | string;

export type SmpPassthroughHandlerResponseBody = any;

export enum SortDirType {
  ASC = 'ASC',
  DESC = 'DESC'
}

export enum SortParamType {
  PLACEMENT_DATE = 'PLACEMENT_DATE',
  SETTLEMENT_DATE = 'SETTLEMENT_DATE',
  CLOSEST_START_TIME = 'CLOSEST_START_TIME'
}

export type SpbPassthroughHandlerRequestBody = Record<string, any> | string;

export type SpbPassthroughHandlerResponseBody = any;

export interface SportInPlayHandlerResponseBody {
  data: InPlayMarketTemplatesView;
}

export interface StaticBanner {
  id: string;
  type: 'STATIC_BANNER';
  image: string;
  link: string;
}

export enum Status {
  Green = 'green',
  Red = 'red'
}

export interface StatusHandlerResponseBody {
  sports: Status;
}

export interface SuspendedCashoutQuote {
  betId: string;
  stake: number;
  originalPotentialWin: number;
  potentialWin: number;
  freeSize: number;
  marketStatus: Record<string, MarketStatus>;
  refreshRate: number;
  quoteStatus: 'SUSPENDED';
}

export type TabConfig =
  | { name: 'MATCHES' | 'COMPETITIONS' | 'SPECIALS' | 'NEXT_RACES' | 'RACE_MEETINGS' | 'FUTURE' }
  | { name: 'IN_PLAY'; inPlayEventsCount: number }
  | ({
      name: 'MATCHES' | 'COMPETITIONS' | 'SPECIALS' | 'NEXT_RACES' | 'RACE_MEETINGS' | 'FUTURE';
    } & { name: 'IN_PLAY'; inPlayEventsCount: number });

export interface Template {
  marketId: MarketId;
  templateId: 'RACE_CARD';
}

export interface TemplateView {
  template: MarketTemplate | EventTemplate | (MarketTemplate & EventTemplate);
}

export interface TranslatedFilters {
  duration: { options: LegacyDurationId[]; selected: LegacyDurationId };
  durations: {
    id: DurationId;
    translationTag: string;
    translationValue: number;
    selected?: true;
    defaultSelected?: true;
  }[];
  marketType: { options: MarketFilter[]; selected: MarketType };
  marketTypes: {
    id: MarketType;
    translationTag: string;
    selected?: true;
    defaultSelected?: true;
  }[];
}

export interface TrueOdds {
  decimalOdds?: DecimalOdds;
  fractionalOdds?: FractionalOdds;
}

export interface UnavailableCashoutQuote {
  betId: string;
  quoteStatus:
    | 'UNAVAILABLE'
    | 'BET_CLOSED'
    | 'NOT_ELIGIBLE'
    | 'QUOTE_TOO_LOW'
    | 'QUOTE_TOO_LOW_FREE_BET'
    | 'LEG_RESULT_PENDING'
    | 'PENDING_CASHOUT';
  freeSize: number;
  marketStatus: Record<string, MarketStatus>;
}

export interface UpcomingEventsHandlerResponseBody {
  data: UpcomingEventsTemplatesView;
}

export interface UpcomingEventsTemplatesView {
  markets: Record<string, MarketView>;
  eventTypes: {
    '1'?: EventTypeView;
    '2'?: EventTypeView;
    '3'?: EventTypeView;
    '4'?: EventTypeView;
    '5'?: EventTypeView;
    '6'?: EventTypeView;
    '7'?: EventTypeView;
    '8'?: EventTypeView;
    '10'?: EventTypeView;
    '11'?: EventTypeView;
    '12'?: EventTypeView;
    '1477'?: EventTypeView;
    '3503'?: EventTypeView;
    '3988'?: EventTypeView;
    '4339'?: EventTypeView;
    '6231'?: EventTypeView;
    '6422'?: EventTypeView;
    '6423'?: EventTypeView;
    '7511'?: EventTypeView;
    '7522'?: EventTypeView;
    '7523'?: EventTypeView;
    '7524'?: EventTypeView;
    '61420'?: EventTypeView;
    '72382'?: EventTypeView;
    '136332'?: EventTypeView;
    '300000'?: EventTypeView;
    '315220'?: EventTypeView;
    '451485'?: EventTypeView;
    '468328'?: EventTypeView;
    '606611'?: EventTypeView;
    '620576'?: EventTypeView;
    '627555'?: EventTypeView;
    '678378'?: EventTypeView;
    '982477'?: EventTypeView;
    '998916'?: EventTypeView;
    '998917'?: EventTypeView;
    '998918'?: EventTypeView;
    '998919'?: EventTypeView;
    '998920'?: EventTypeView;
    '1938544'?: EventTypeView;
    '2152880'?: EventTypeView;
    '2378961'?: EventTypeView;
    '2593174'?: EventTypeView;
    '2872194'?: EventTypeView;
    '2901849'?: EventTypeView;
    '3088925'?: EventTypeView;
    '4609466'?: EventTypeView;
    '4726642'?: EventTypeView;
    '5412697'?: EventTypeView;
    '15826206'?: EventTypeView;
    '26420387'?: EventTypeView;
    '27065662'?: EventTypeView;
    '27105927'?: EventTypeView;
    '27388198'?: EventTypeView;
    '27454571'?: EventTypeView;
    '27485048'?: EventTypeView;
    '27589895'?: EventTypeView;
    '28347302'?: EventTypeView;
    '28361982'?: EventTypeView;
    '28578623'?: EventTypeView;
    '28608996'?: EventTypeView;
    '28609007'?: EventTypeView;
    '29125756'?: EventTypeView;
  };
  competitions: Record<string, CompetitionView>;
  events: Record<string, EventView>;
  groups: TemplateView[][][];
}

export interface WalletInfo {
  hasBonusCash: boolean;
  hasFreeBets: boolean;
}

/**
 * ======================================== Place Bets ========================================
 */
export enum WalletTypeEnum {
  DEPOSITS = 'DEPOSITS',
  WINNINGS = 'WINNINGS',
  WAGERING = 'WAGERING',
  BONUS_CASH = 'BONUS_CASH',
  BONUSES = 'BONUSES'
}
